import React from 'react';
import { styled } from 'linaria/lib/react';
import Image from 'next/image';
import { Heading, Link, List, Text, theme } from '@mtsbank/ui-kit';
import top20 from '@asserts/images/cyber/slider/top20.jpg';
import top20Slide from '@asserts/images/cyber/slider/top20Slide.jpg';
import promoInarius from '@asserts/images/cyber/slider/promoInarius.jpg';
import promoInariusResult from '@asserts/images/cyber/slider/inariusResult.jpg';
import cardMir from '@asserts/images/cyber/slider/cardMir.jpg';
import steam from '@asserts/images/cyber/slider/steam.jpg';
import steamSlide from '@asserts/images/cyber/slider/steamSlide.jpg';
import awards from '@asserts/images/cyber/slider/awards.jpg';
import awardsSlide from '@asserts/images/cyber/slider/awardsSlide.jpg';
import hitSteam from '@asserts/images/cyber/slider/hitSteam.jpg';
import hitSteamSlide from '@asserts/images/cyber/slider/hitSteamSlide.jpg';
import bestGames from '@asserts/images/cyber/slider/bestGames.jpg';
import bestGamesSlide from '@asserts/images/cyber/slider/bestGamesSlide.jpg';
import regionSteam from '@asserts/images/cyber/slider/regionSteam.jpg';
import regionSteamSlide from '@asserts/images/cyber/slider/regionSteamSlide.jpg';
import regionSteamIn from '@asserts/images/cyber/slider/regionSteamIn.jpg';
import buySteamSlide from '@asserts/images/cyber/slider/buySteamSlide.jpg';
import buySteam from '@asserts/images/cyber/slider/buySteam.jpg';
import top10Slide from '@asserts/images/cyber/slider/top10Slide.jpg';
import top10 from '@asserts/images/cyber/slider/top10.jpg';
import nyGift from '@asserts/images/cyber/slider/NYGiftNews.jpg';
import nyGiftItogi from '@asserts/images/cyber/slider/itogiNG.jpg';
import vesenniiRozygrysh from '@asserts/images/cyber/slider/vesenniiRozygrysh.jpg';
import vesenniiRozygryshItogi from '@asserts/images/cyber/slider/vesenniiRozygryshItogi.jpg';
import { Spacer } from '../Uikit/Spacer';
import { STEAM_URL } from '../Cyber/constansts';
const NewCardLink = /*#__PURE__*/styled(Link)({
  name: "NewCardLink",
  class: "nbx011j"
});
const Ol = /*#__PURE__*/styled("ol")({
  name: "Ol",
  class: "o1cdzbb6"
});
const WrapperList = /*#__PURE__*/styled("div")({
  name: "WrapperList",
  class: "wdedn8n"
});
export const News = {
  'rozygrysh-prizov-itogi': {
    id: 'rozygrysh-prizov-itogi',
    title: 'Розыгрыш 500\u00A0000\u00A0₽ завершён',
    describe: 'Список участников и\u00A0победителей определён',
    date: '20.04.2025',
    imageSlide: vesenniiRozygryshItogi
  },
  'rozygrysh-prizov': {
    id: 'rozygrysh-prizov',
    title: 'Разыгрываем 500\u00A0000\u00A0₽',
    describe: 'Совершите от 3 покупок с\u00A020 марта по\u00A010\u00A0апреля и\u00A0выиграйте денежный приз',
    date: '20.03.2025',
    imageSlide: vesenniiRozygrysh
  },
  'novogodniy-rozygrysh-prizov-itogi': {
    id: 'novogodniy-rozygrysh-prizov-itogi',
    title: 'Итоги розыгрыша 500\u00A0000\u00A0₽',
    describe: 'Список участников и\u00A0победителей определён',
    date: '16.01.2025',
    imageSlide: nyGiftItogi
  },
  'novogodniy-rozygrysh-prizov': {
    id: 'novogodniy-rozygrysh-prizov',
    title: 'Разыгрываем 500\u00A0000\u00A0₽',
    describe: 'Участвуйте и\u00A0выиграйте денежный приз\u00A0',
    date: '13.12.2024',
    imageSlide: nyGift
  },
  'ozhidayemyye-igry-2024': {
    id: 'ozhidayemyye-igry-2024',
    title: 'Самые ожидаемые игры 2024',
    describe: 'ТОП-10 предстоящих новинок',
    describeFull: <>
        <Text color="white">
          Игровая индустрия не&nbsp;перестаёт удивлять новаторскими идеями, впечатляющей графикой и&nbsp;увлекательными
          сюжетами. В&nbsp;этом году разработчики готовят к&nbsp;выпуску проекты, которые обещают установить новые
          стандарты в&nbsp;разных жанрах и&nbsp;принести свежие впечатления даже самым искушенным игрокам.
          От&nbsp;эпических приключений в&nbsp;фантастических мирах до&nbsp;напряжённых тактических шутеров
          и&nbsp;креативных инди-проектов&nbsp;&mdash; рассказываем, чего ожидать в&nbsp;2024&nbsp;году.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Dragon Age: Dreadwolf
        </Heading>
        <Text color="white">
          Осенью 2024 года ожидается выход Dragon Age: Dreadwolf. Это фэнтезийная экшен-RPG, продолжение Dragon Age:
          Inquisition. Ее&nbsp;заслуженно можно назвать одной из&nbsp;самых ожидаемых игр&nbsp;&mdash; ведь поклонники
          находятся в&nbsp;предвкушении уже десять лет.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Сюжет построен вокруг истории мага-самоучки Соласа. В&nbsp;прошлых играх серии он&nbsp;был компаньоном
          основного персонажа. В&nbsp;этой части его роль доподлинно неизвестна, но, судя по&nbsp;трейлеру,
          он&nbsp;скрывает множество тайн. Кроме того, должен появиться новый главный герой.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Где будут разворачиваться события&nbsp;&mdash; пока тоже загадка. Вероятнее всего, дело не&nbsp;ограничится
          одним государством. Кто знает, возможно, весь Тедас станет ареной для игровых сражений.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          По&nbsp;словам разработчиков, новая часть создаётся для одиночного прохождения. В&nbsp;ней не&nbsp;будет
          привычного мультиплеера. Пролить свет на&nbsp;все тайны Dragon Age: Dreadwolf создатели намерены летом
          текущего года. Возможно, они озвучат не&nbsp;только точную дату выхода, но&nbsp;и&nbsp;подробности геймплея,
          поддерживаемые игровые платформы и&nbsp;т.&nbsp;п.
        </Text>
        <Spacer space={24} spacemob={16} />

        <Heading h={3} color="white">
          Hades 2
        </Heading>
        <Text color="white">
          Дата выхода Hades&nbsp;&mdash; 6&nbsp;мая 2024&nbsp;года, в&nbsp;раннем доступе только на&nbsp;ПК.
          Разработчики обещают яркие локации, интересных боссов и&nbsp;множество предметов для создания уникальных
          билдов.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          По&nbsp;сценарию бессмертная принцесса подземного мира Мелиноя должна спасти Аида. Его взял в&nbsp;плен
          сбежавший из&nbsp;заточения титан. Главная героиня должна справиться с&nbsp;армией мертвецов, осаждающих
          Олимп, и&nbsp;победить Кроноса.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Сюжетно игра хоть и&nbsp;стала продолжением первой части, но&nbsp;рассматривается как самостоятельная. Первая
          локация узнаваема и&nbsp;практически неизменна, а&nbsp;остальные можно смело назвать уникальными,
          с&nbsp;множеством особенностей. Они существенно меняют игровой опыт. &laquo;Боевая&raquo; составляющая стала
          другой. Теперь у&nbsp;героев совершенно новое оружие, каждый получил по&nbsp;две обычные и&nbsp;две заряженные
          атаки, а&nbsp;также сигил &mdash;заклинание, которое останавливает врагов и&nbsp;наносит им&nbsp;урон
          (в&nbsp;заряженной версии).
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Повторимся, что пока речь идет только о&nbsp;раннем доступе и&nbsp;справедливости ради напомним, что первая
          версия &laquo;оттачивалась&raquo; таким способом почти два года, так что пока не&nbsp;судите строго.
        </Text>
        <Spacer space={24} spacemob={16} />

        <Heading h={3} color="white">
          Vampire: The Masquerade&nbsp;&mdash; Bloodlines&nbsp;2
        </Heading>
        <Text color="white">
          Новинка обещает быть захватывающим продолжением культовой игры, которая стала иконой ролевых проектов ещё
          в&nbsp;далеком 2004&nbsp;году.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          События разворачиваются в&nbsp;современном Сиэтле, где игроку предстоит взять на&nbsp;себя роль древнего
          вампира, проснувшегося после трехсотлетнего сна. Главная задача игрока&nbsp;&mdash; выбрать клан вампиров
          и&nbsp;привести его к&nbsp;славе.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Подобно первой части, много внимания уделяется ролевым аспектам. Выбор игрока существенно влияет на&nbsp;ход
          сюжета, на&nbsp;отношения с&nbsp;другими персонажами, а&nbsp;также на&nbsp;исход квестов.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Обещают также много нового. И&nbsp;это неудивительно, учитывая &laquo;судьбу&raquo; разработчиков. Работу над
          проектом начинала студия Hardsuit Labs, но&nbsp;после ряда внутренних проблем и&nbsp;пертурбаций было принято
          решение передать ответственную миссию студии The Chinese Room, известной по&nbsp;играм Amnesia: A&nbsp;Machine
          for Pigs и&nbsp;Everybody&rsquo;s Gone to&nbsp;the Rapture.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Обещают также много нового. И&nbsp;это неудивительно, учитывая &laquo;судьбу&raquo; разработчиков. Работу над
          Новая команда разработчиков решила пересмотреть многие аспекты игры, в&nbsp;том числе сюжет и&nbsp;геймплейные
          механики. Подробностей об&nbsp;изменениях пока нет, но&nbsp;ожидается, что новые разработчики внесут свой
          вклад в&nbsp;проект, сохраняя при этом его уникальность и&nbsp;уже узнаваемую атмосферу.
        </Text>
        <Spacer space={24} spacemob={16} />

        <Heading h={3} color="white">
          Star Wars Outlaws
        </Heading>
        <Text color="white">
          Игра в&nbsp;жанре экшн-приключение с&nbsp;открытым миром разрабатывается компанией Massive Entertainment. Она
          была анонсирована в&nbsp;2023 году и&nbsp;вызвала большой интерес у&nbsp;фанатов &laquo;Звёздных войн&raquo;.
          Выход на&nbsp;ПК запланирован на&nbsp;2024&nbsp;год, что обещает стать значимым событием в&nbsp;мире видеоигр.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Действие разворачивается в&nbsp;захватывающий период между фильмами &laquo;Империя наносит ответный
          удар&raquo; и&nbsp;&laquo;Возвращение джедая&raquo;. Это время, когда Галактическая Империя на&nbsp;пике своей
          мощи, а&nbsp;повстанцы изо всех сил пытаются противостоять ее&nbsp;тирании. На&nbsp;фоне этой эпической борьбы
          игрокам предстоит примерить на&nbsp;себя роль Кэй Весс, молодой мошенницы, которая ищет свое место в&nbsp;этом
          опасном мире. Она стремится провернуть одно из&nbsp;самых дерзких ограблений в&nbsp;истории галактики, что
          требует ловкости, смекалки и&nbsp;немалой удачи. Игроки смогут исследовать различные планеты, участвовать
          в&nbsp;захватывающих миссиях и&nbsp;взаимодействовать с&nbsp;множеством персонажей, как знакомых, так
          и&nbsp;новых.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Геймплей Star Wars Outlaws сочетает элементы боев и&nbsp;стелса, что позволяет игрокам выбирать свой стиль
          прохождения. Можно вступать в&nbsp;открытые бои с&nbsp;врагами, использовать различные виды оружия
          и&nbsp;техники, а&nbsp;также прибегать к&nbsp;скрытным методам, чтобы избегать ненужных столкновений. Важной
          частью игры станет управление транспортными средствами, включая культовые космические корабли, что добавит ещё
          больше свободы и&nbsp;динамики в&nbsp;игровой процесс.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">Разработчики обещают высокое качество графики и&nbsp;детализации.</Text>
        <Spacer space={24} spacemob={16} />

        <Heading h={3} color="white">
          S.T.A.L.K.E.R. 2: Heart of&nbsp;Chornobyl
        </Heading>
        <Text color="white">
          Разработанная студией GSC Game World, эта игра представляет собой продолжение культовой серии S.T.A.L.K.E.R.,
          известной своими атмосферными и&nbsp;напряжёнными сюжетами. Дата выхода на&nbsp;ПК&nbsp;&mdash;
          5&nbsp;сентября 2024&nbsp;года.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Действие разворачивается в&nbsp;альтернативной реальности, где Чернобыльская зона отчуждения стала источником
          аномалий и&nbsp;мутаций после второй катастрофы. Эти события превратили ее&nbsp;в&nbsp;смертельно опасное
          место, где законы физики и&nbsp;биологии нарушены. Игроки снова окажутся в&nbsp;роли сталкеров&nbsp;&mdash;
          людей, которые рискуют жизнью, чтобы исследовать Зону в&nbsp;поисках артефактов и&nbsp;других ценных ресурсов.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Разработчики обещают глубокий и&nbsp;многослойный сюжет с&nbsp;многочисленными поворотами и&nbsp;вызовами,
          зависящими от&nbsp;решений игрока. Вам предстоит взаимодействовать с&nbsp;различными фракциями, каждая
          из&nbsp;которых имеет свои цели и&nbsp;методы, что добавляет приключению стратегической глубины
          и&nbsp;разнообразия.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Heart of&nbsp;Chornobyl&nbsp;&mdash; это живой изменяющийся мир, полный опасностей и&nbsp;аномалий. Игроки
          смогут исследовать заброшенные здания, подземные комплексы и&nbsp;дикие ландшафты, встречая на&nbsp;своём пути
          как врагов, так и&nbsp;союзников. Неповторимая атмосфера Зоны создаётся высококачественной графики
          и&nbsp;звукового оформления, что делает игру ещё более погружающей и&nbsp;реалистичной.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Геймплей S.T.A.L.K.E.R. 2&nbsp;сочетает элементы шутера от&nbsp;первого лица, ролевой игры и&nbsp;хоррора.
          Игрокам предстоит сражаться с&nbsp;различными врагами, включая мутантов и&nbsp;других сталкеров, использовать
          разнообразное оружие и&nbsp;экипировку, а&nbsp;также исследовать опасные аномалии и&nbsp;искать ценные
          артефакты. Важным аспектом игры станет управление ресурсами и&nbsp;планирование действий, так как Зона
          не&nbsp;прощает ошибок и&nbsp;неосторожности.
        </Text>
        <Spacer space={24} spacemob={16} />

        <Heading h={3} color="white">
          Warhammer&nbsp;40,000: Space Marine&nbsp;2
        </Heading>
        <Text color="white">
          Выход Warhammer&nbsp;40,000: Space Marine 2&nbsp;на ПК&nbsp;в&nbsp;Steam, Xbox Series, PlayStation
          5&nbsp;ожидается 9&nbsp;сентября 2024&nbsp;года. Это продолжение знаменитого экшн-шутера от&nbsp;студии Saber
          Interactive.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Действие разворачивается в&nbsp;далеком будущем, где Империум Человечества ведет бесконечную войну против
          множества врагов. Игроки снова возьмут на&nbsp;себя роль капитана Титуса, ветерана ордена Ультрамаринов. Сюжет
          игры обещает быть насыщенным и&nbsp;эпическим, полным жестоких сражений и&nbsp;подвигов. На&nbsp;этот раз
          Титус и&nbsp;его боевые братья столкнутся с&nbsp;угрозой тиранидов&nbsp;&mdash; смертоносных инопланетных
          существ, известных своей безжалостностью и&nbsp;ненасытным голодом. Игрокам предстоит отправиться в&nbsp;новые
          миры, чтобы сразиться с&nbsp;этой угрозой и&nbsp;защитить человечество.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Warhammer&nbsp;40,000: Space Marine 2&nbsp;сохранит ключевые элементы геймплея оригинальной игры
          и&nbsp;дополнится механикой, различными улучшениями. Игроки смогут снова насладиться напряжёнными боями, где
          они будут использовать как огнестрельное, так и&nbsp;холодное оружие. Титус сможет переключаться между
          стрельбой и&nbsp;ближним боем, используя свои знаменитые болтер и&nbsp;силовой меч, чтобы разрывать врагов
          на&nbsp;части.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Одна из&nbsp;главных особенностей игры&nbsp;&mdash; это масштабные эпические битвы. Мир Space Marine
          2&nbsp;будет мрачным и&nbsp;беспощадным, полным опасностей и&nbsp;ужаса. Игроки смогут исследовать различные
          планеты, каждая из&nbsp;которых имеет свои уникальные ландшафты и&nbsp;врагов.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Разработчики обещают реалистичные эффекты боя, включая кровавые сцены и&nbsp;разрушения.
        </Text>
        <Spacer space={24} spacemob={16} />

        <Heading h={3} color="white">
          The Thaumaturge
        </Heading>
        <Text color="white">
          Перед нами ещё одна захватывающая игра. События разворачиваются в&nbsp;1905 году в&nbsp;Варшаве, находящейся
          под властью Российской империи. Вам предстоит взять на&nbsp;себя роль тауматурга по&nbsp;имени Виктор Шульски,
          который исследует город и&nbsp;ищет потусторонних существ, воплощенных в&nbsp;местных жителях.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Одна из&nbsp;ключевых особенностей The Thaumaturge&nbsp;&mdash; большая свобода выбора. Игрокам
          предоставляется возможность принимать решения, влияющие на&nbsp;развитие сюжета, и&nbsp;исследовать богатый
          мир, который каждый раз раскрывается по-разному.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Разработкой игры занимаются специалисты студии CD&nbsp;Projekt RED, известной по&nbsp;серии
          &laquo;Ведьмак&raquo;, а&nbsp;значит, можно небезосновательно рассчитывать на&nbsp;высокий уровень проработки
          сюжета и&nbsp;увлекательные побочные квесты.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Во&nbsp;многом необычность новинки обусловлена выбором локации. Перед нами Варшава начала 20&nbsp;века.
          Согласитесь, на ум&nbsp;приходит немного сюжетов из&nbsp;этой местности. Изометрический вид игры позволяет
          создать красочный и живописный облик города, где в&nbsp;постоянном противостоянии сталкиваются нищета одних
          районов и&nbsp;богатство других.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Новинка обещает стать уникальным и&nbsp;захватывающим опытом для любителей ролевых игр.
        </Text>
        <Spacer space={24} spacemob={16} />

        <Heading h={3} color="white">
          Avowed
        </Heading>
        <Text color="white">
          Игра в&nbsp;жанре ролевого экшена от&nbsp;первого лица разработана студией Obsidian Entertainment. Она
          анонсирована в&nbsp;2020 году и&nbsp;ожидается осенью 2024&nbsp;года. Вызывает большой интерес
          у&nbsp;поклонников RPG благодаря обещаниям глубокого сюжета и&nbsp;проработанной вселенной. События
          разворачиваются в&nbsp;фантастическом мире Эора, который фанаты Obsidian уже знают по&nbsp;серии игр Pillars
          of&nbsp;Eternity. Эора&nbsp;&mdash; это мир, полный магии, мифических существ и&nbsp;древних тайн. В&nbsp;роли
          главного игрового персонажа вы&nbsp;отправитесь в&nbsp;путешествие, чтобы раскрыть тайны загадочного мира
          и&nbsp;сразиться с&nbsp;его опасностями.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Avowed предлагает игрокам геймплей от&nbsp;первого лица с&nbsp;акцентом на&nbsp;магию и&nbsp;сражения. Игроки
          смогут выбирать между различными классами и&nbsp;умениями, чтобы создать уникального персонажа.
          В&nbsp;арсенале будут как магические заклинания, так и&nbsp;холодное оружие, что позволит разнообразить
          подходы к&nbsp;битвам.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Игра предложит исследование открытого мира, который будет наполнен квестами, скрытыми локациями
          и&nbsp;множеством секретов. Игроки смогут путешествовать по&nbsp;разнообразным ландшафтам&nbsp;&mdash;
          от&nbsp;густых лесов до&nbsp;мрачных подземелий, каждый из&nbsp;которых будет иметь свои уникальные
          особенности и&nbsp;врагов.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Графика и&nbsp;визуальный стиль игры обещают быть впечатляющими благодаря использованию современных
          технологий. Разработчики стремятся создать мир, который будет не&nbsp;только красивым,
          но&nbsp;и&nbsp;погружающим, с&nbsp;детализированным окружением и&nbsp;реалистичными эффектами.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Игра разрабатывается на&nbsp;движке Unreal Engine&nbsp;5, что позволит добиться высокого уровня графики
          и&nbsp;производительности. Она будет доступна на&nbsp;платформах Xbox Series X|S и&nbsp;ПК, что обеспечит
          широкий охват аудитории и&nbsp;позволит насладиться геймерским опытом в&nbsp;максимальном качестве.
        </Text>
        <Spacer space={24} spacemob={16} />

        <Heading h={3} color="white">
          Hollow Knight: Silksong
        </Heading>
        <Text color="white">
          Это долгожданное продолжение культовой игры Hollow Knight от&nbsp;австралийской студии Team Cherry. Главная
          героиня&nbsp;&mdash; Хорнет&nbsp;&mdash; принцесса-защитница, известная по&nbsp;первой части игры. Она
          оказывается в&nbsp;незнакомом королевстве, полном вызовов и&nbsp;врагов. Ее&nbsp;задача&nbsp;&mdash; подняться
          на&nbsp;вершину этого королевства и&nbsp;раскрыть его секреты.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Silksong сохраняет основные элементы игровой механики, полюбившиеся фанатам первой части, включая исследование
          разветвленного мира, напряжённые бои и&nbsp;глубокую систему улучшений. В&nbsp;то&nbsp;же время игра добавляет
          множество новых возможностей:
        </Text>
        <Spacer space={24} spacemob={16} />
        <WrapperList>
          <List data={[{
          id: 1,
          text: 'боевые приемы\u00A0- Хорнет обладает уникальными способностями, которые позволяют ей\u00A0совершать головокружительные акробатические трюки и\u00A0использовать смертоносное оружие;'
        }, {
          id: 2,
          text: 'исследование нового королевства\u00A0- обещают более 150 новых локаций, от\u00A0залитых солнцем цитаделей до\u00A0тенистых лесов и\u00A0глубоких пещёр;'
        }, {
          id: 3,
          text: 'улучшения\u00A0- можно создавать и\u00A0улучшать различные предметы и\u00A0оружие, что добавляет стратегической глубины и\u00A0вариативности.'
        }]} bulletColorType="gray" size="md" sizemob="sm" />
        </WrapperList>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Hollow Knight: Silksong сохраняет великолепный визуальный стиль оригинала, который сочетает детализированную
          2D-анимацию с&nbsp;мрачной и&nbsp;завораживающей атмосферой. Если вы&nbsp;любите сложные игры с&nbsp;глубоким
          сюжетом и&nbsp;насыщенным игровым процессом, эта определенно заслуживает вашего внимания.
        </Text>
        <Spacer space={24} spacemob={16} />

        <Heading h={3} color="white">
          Silent Hill&nbsp;2
        </Heading>
        <Text color="white">
          Перед нами одна из&nbsp;самых ожидаемых игр года для поклонников хоррора&nbsp;&mdash; ремейк легендарной
          Silent Hill. Джеймс Сандерленд получает загадочное письмо от&nbsp;своей покойной жены. Она приглашает его
          вернуться в&nbsp;город, где они вместе пережили важные моменты. Сегодня это место хранит множество страшных
          тайн и&nbsp;опасностей. Игрокам предстоит исследовать заброшенные улицы, темные коридоры и&nbsp;зловещие
          локации, чтобы раскрыть тайну письма и&nbsp;победить внутренних демонов Джеймса.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Сценарий новинки практически полностью повторяет оригинал, а&nbsp;вот графику обещают значительно улучшить.
          Современные технологии позволяют разработчикам создать невероятно реалистичные и&nbsp;детализированные игровые
          сцены, которые усиливают чувство страха и&nbsp;тревоги. Звуковое сопровождение и&nbsp;музыкальные композиции
          от&nbsp;культового композитора Акиты Ямаока воссоздают давно полюбившуюся атмосферу игры.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Разработчики сохранили многие классические элементы геймплея, которые нравятся фанатам оригинала,
          но&nbsp;добавили новые механики для более глубокого погружения. Игрокам предстоит решать головоломки,
          сражаться с&nbsp;жуткими монстрами и&nbsp;исследовать множество локаций в&nbsp;поисках ответов. Особое
          внимание уделено психологии персонажей и&nbsp;их&nbsp;взаимодействию с&nbsp;окружающим миром, что делает игру
          ещё более захватывающей и&nbsp;напряжённой.
        </Text>
        <Spacer space={24} spacemob={16} />

        <Heading h={3} color="white">
          Little Nightmares&nbsp;3
        </Heading>
        <Text color="white">
          Среди самых ожидаемых новинок года особое место занимает Little Nightmares&nbsp;3. Эта игра обещает продолжить
          традиции серии, погружая игроков в&nbsp;новую реальность, полную тайн и&nbsp;опасностей. Героям предстоит
          окунуться в&nbsp;зловещий мир, где они будут управлять новыми персонажами, пытающимися выжить в&nbsp;кошмарном
          окружении. Хотя разработчики держат сюжетные детали в&nbsp;секрете, известно, что игра продолжит традицию
          своих предшественников, а&nbsp;значит, нас ждут уникальные истории и&nbsp;глубокие эмоциональные переживания.
          Предполагается, что играть вы&nbsp;будете с&nbsp;напарником, а&nbsp;если друга геймера у&nbsp;вас нет, его
          роль возьмет на&nbsp;себя &laquo;коллега-бот&raquo; под руководством искусственного интеллекта.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Графика в&nbsp;Little Nightmares 3&nbsp;обещает быть ещё более впечатляющей, чем в&nbsp;предыдущих частях.
          Детализированное окружение, игра света и&nbsp;тени, а&nbsp;также уникальный визуальный стиль создадут
          неповторимую атмосферу, которая заставит каждого почувствовать себя частью этого пугающего мира. Звуковое
          сопровождение усилит напряжёние.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Новые персонажи получат уникальные способности, что сделает игровой процесс непрогнозируемым
          и&nbsp;увлекательным.
        </Text>
        <Spacer space={24} spacemob={16} />

        <Heading h={3} color="white">
          Helldivers&nbsp;2
        </Heading>
        <Text color="white">
          Helldivers 2&nbsp;&mdash; это кооперативный шутер от&nbsp;третьего лица, который представляет собой
          захватывающее приключение в&nbsp;духе фильма &laquo;Звездный десант&raquo;. Вам предстоит уничтожать огромные
          колонии инопланетных монстров, используя вооружение и&nbsp;тактику вместе с&nbsp;друзьями.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Одна из&nbsp;особенностей игры&nbsp;&mdash; система дружественного огня, которая позволяет игрокам помогать
          друг другу. В&nbsp;то&nbsp;же время не&nbsp;исключен риск случайно нанести урон своим товарищам, так что стоит
          быть предельно внимательными. Такой прием разработчиков создаёт динамичный и&nbsp;захватывающий геймплей, где
          сотрудничество и&nbsp;взаимодействие играют важную роль.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Сюжет игры переносит нас в&nbsp;будущее, где элитный отряд Адских десантников сражается за&nbsp;свободу
          и&nbsp;мир на&nbsp;планете Суперземля, борясь с&nbsp;огромными жуками и&nbsp;роботами.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Helldivers 2&nbsp;обещает разнообразные и&nbsp;непредсказуемые миссии, включая бои в&nbsp;джунглях, пустынях
          и&nbsp;других локациях. Игроки смогут разделяться и&nbsp;выполнять различные задачи, но&nbsp;в&nbsp;конечном
          счете они объединятся для сражения с&nbsp;мощными боссами.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Нововведение в&nbsp;Helldivers 2&nbsp;&mdash; это возможность управления персонажами с&nbsp;камерой из-за
          спины, что добавляет дополнительную глубину и&nbsp;иммерсию в&nbsp;игровой процесс. Механики из&nbsp;оригинала
          сохранены, а&nbsp;динамика действий усилена.
        </Text>
        <Spacer space={24} spacemob={16} />

        <Heading h={3} color="white">
          Frostpunk&nbsp;2
        </Heading>
        <Text color="white">
          Выход Frostpunk 2&nbsp;запланирован на&nbsp;25&nbsp;июля. Это продолжение культовой стратегии
          с&nbsp;элементами выживания. Действие разворачивается в&nbsp;альтернативном 1916&nbsp;году, где холод уже
          не&nbsp;так силен, но&nbsp;продолжает оказывать влияние на&nbsp;жизнь города Нью-Лондон. Игроку предстоит
          взять на&nbsp;себя роль управляющего городом и&nbsp;обеспечить его жителей всем необходимым.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Тепло, убежища, еда, материалы,&nbsp;&mdash; нужно умело балансировать, чтобы не&nbsp;допустить дефицита
          ни&nbsp;одного из&nbsp;ресурсов. В&nbsp;противном случае можно потерять доверие жителей города. Но&nbsp;это
          не&nbsp;единственная опасность. Придется также учитывать мнение различных фракций, в&nbsp;частности Машинистов
          и&nbsp;Собирателей. Первые отстаивают использование технологий, даже если это влечет за&nbsp;собой
          экологические последствия, в&nbsp;то&nbsp;время как вторые предпочитают традиционный подход с&nbsp;ручным
          трудом.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          Предшественник Frostpunk 2&nbsp;завоевал сердца игроков своей атмосферой, механикой выживания
          и&nbsp;моральными дилеммами. Игрокам приходится управлять последним городом на&nbsp;Земле, принимая сложные
          решения и&nbsp;борясь за&nbsp;выживание своего народа в&nbsp;условиях крайних холодов. На&nbsp;этот раз
          разработчики обещают ещё более серьезные дилеммы и&nbsp;сложные испытания. Что&nbsp;ж, ждать осталось недолго.
        </Text>
        <Spacer space={24} spacemob={16} />
        <Text color="white">
          А&nbsp;чтобы купить любые новинки в&nbsp;Стиме 2024 году&nbsp;&mdash; используют сервис{' '}
          <NewCardLink href={STEAM_URL}>МТС&nbsp;Оплата</NewCardLink>. С&nbsp;его помощью можно пополнить кошелек
          с&nbsp;карты любого российского банка по&nbsp;СБП с&nbsp;низкой комиссией. Выберите вариант пополнения
          и&nbsp;следуйте подсказкам системы&nbsp;&mdash; средства будут зачислены в&nbsp;срок от&nbsp;15&nbsp;минут.
        </Text>
        <Spacer space={24} spacemob={16} />
      </>,
    date: '12.07.2024',
    imagePage: top10,
    imageSlide: top10Slide,
    titleMeta: 'Самые ожидаемые игры 2024: ТОП-10 предстоящих новинок',
    descriptionMeta: 'Рассмотрим самые ожидаемые игры 2024 года: Dragon Age: Dreadwolf, Hades 2, Star Wars Outlaws и другие новинки.'
  },
  'promo-inarius-itogy': {
    id: 'promo-inarius-itogy',
    title: 'Итоги розыгрыша статуи Инария из\u00A0Diablo\u00A0IV',
    describe: 'Список участников и\u00A0победителей определен',
    date: '11.07.2024',
    imageSlide: promoInariusResult
  },
  'mts-cashback-lite-mir': {
    id: 'mts-cashback-lite-mir',
    title: 'Виртуальная карта MTS\u00A0CASHBACK\u00A0LITE\u00A0Мир',
    describe: 'С\u00A0кешбэком до\u00A050% за\u00A0пополнение игровых кошельков',
    date: '10.06.2024',
    imageSlide: cardMir
  },
  'promo-inarius': {
    id: 'promo-inarius',
    title: 'Выиграйте статую Инария из\u00A0Diablo IV',
    describe: 'Условия участия и победы в розыгрыше',
    date: '03.06.2024',
    imageSlide: promoInarius
  },
  top_20_samykh_populyarnykh_igr: {
    id: 'top_20_samykh_populyarnykh_igr',
    title: 'Топ-20 лучших игр для ПК',
    describe: 'Рейтинг компьютерных игр по версии пользователей',
    describeFull: <>
        <Text color="white">
          Из&nbsp;года в&nbsp;год разработчики игр на&nbsp;ПК всё активнее радуют геймеров качественным контентом.
          И&nbsp;пока профи с&nbsp;нетерпением ожидают конкретных релизов, новички и&nbsp;любители теряются
          в&nbsp;океане сиквелов, ремейков и&nbsp;оригинальных новинок. Мы&nbsp;собрали топ-20 лучших игр, чтобы
          сэкономить ваше время и&nbsp;облегчить поиск по-настоящему крутых сюжетов.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Resident Evil 4
        </Heading>
        <Text color="white">
          Resident Evil 4&nbsp;&mdash; игра в&nbsp;жанре survival-хоррора, в&nbsp;которой спецагент Леон Кеннеди
          отправляется в&nbsp;отдалённую испанскую деревню, чтобы спасти дочь президента США. Герой сталкивается
          с&nbsp;жуткими существами, заражёнными таинственным вирусом, и&nbsp;узнаёт о&nbsp;страшном заговоре.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Первая игра серии Resident Evil вышла в&nbsp;1996&nbsp;году, а&nbsp;Resident Evil 4&nbsp;увидела мир
          в&nbsp;2005-м. Вслед за&nbsp;ней вышли пятая, шестая и&nbsp;седьмая части, и&nbsp;параллельно с&nbsp;развитием
          серии началась эра ремейков.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Ремейк четвертой части появился в&nbsp;2023 году&nbsp;&mdash; стало больше экшена, изменился геймплей,
          появились разнообразные сценарии сражений. Каждая схватка стала особенной&nbsp;&mdash; секунду назад
          на&nbsp;героя сыпались бомбы, а&nbsp;теперь против него расставили капканы; ему едва удалось увернуться
          от&nbsp;бензопилы, как он&nbsp;тут&nbsp;же стал жертвой кровавого великана.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Пожалуй, это один лучших примеров того, как &laquo;забытое старое&raquo; становится новым и&nbsp;интересным.
          Из&nbsp;игры убрали все моменты, утратившие актуальность, но&nbsp;сохранили оригинальный сюжет.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Поиграть в&nbsp;Resident Evil 4&nbsp;можно в&nbsp;Steam на&nbsp;ПК, на&nbsp;PlayStation 5, PlayStation 4, Xbox
          Series X|S, Xbox One, macOS, iOS.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Чтобы пройти игру целиком, вам понадобится около 20&nbsp;часов.</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Baldur&#39;s Gate III
        </Heading>
        <Text color="white">
          Baldur&#39;s Gate 3&nbsp;&mdash; легендарное и&nbsp;очень долгожданное продолжение умной RPG Baldur&rsquo;s
          Gate. Первая и&nbsp;вторая части вышли в&nbsp;1998 и&nbsp;2000 годах соответственно. Их&nbsp;успех вдохновил
          создателей на&nbsp;дальнейшую серьёзную работу. На&nbsp;протяжении шести лет они прорабатывали сценарий,
          анимировали персонажей, совершенствовали графику и&nbsp;продумывали мельчайшие детали, чтобы поклонники смогли
          высоко оценить игрушку, а&nbsp;мы&nbsp;&mdash; включить её&nbsp;в&nbsp;топ лучших игр на&nbsp;ПК.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Baldur&#39;s Gate 3&nbsp;нелинейная. Вы&nbsp;каждый раз выбираете свой путь, решаете проблемы разными
          способами&nbsp;и, соответственно, получаете разный исход.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Над городом Врата Балдура замечен корабль иллитидов, загадочных и&nbsp;зловещих существ из&nbsp;недр Подземья.
          Они похищают людей, заселяют их&nbsp;мозг паразитами и&nbsp;превращают в&nbsp;новых иллитидов. Игроку,
          ставшему одним из&nbsp;узников, удаётся сбежать, но&nbsp;его мозг уже заражен. Паразит прогрессирует,
          и&nbsp;времени найти способ избавиться от&nbsp;него совсем мало.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Доступность: ПК&nbsp;&mdash; Steam и&nbsp;GOG, PlayStation 5, Xbox Series</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Alan Wake 2
        </Heading>
        <Text color="white">
          Alan Wake 2&nbsp;заслуженно занимает своё место в&nbsp;нашем топе игр на&nbsp;ПК. Это безоговорочный лидер
          в&nbsp;ААА-сегменте и&nbsp;отличный пример того, как оригинал может быть улучшен и&nbsp;расширен. В&nbsp;игре
          есть что-то от&nbsp;&laquo;Твин Пикс&raquo;, &laquo;Солнцестояния&raquo; и&nbsp;&laquo;Ведьмы&raquo;,
          да&nbsp;и&nbsp;вообще игрой её&nbsp;называть как-то язык не&nbsp;поворачивается. Это нечто большее, что-то
          на&nbsp;грани геймерской реальности и&nbsp;кинематографа.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Получилось очень атмосферно: высококачественная графика, видеоролики с&nbsp;настоящими актерами, пугающие
          скримеры и&nbsp;очень реалистичная двойная экспозиция.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          События разворачиваются в&nbsp;городке Брайт Фоллс. Агенты ФБР расследуют серию убийств с&nbsp;ритуальным
          подтекстом. Улики приводят их&nbsp;к&nbsp;Алану Уэйку&nbsp;&mdash; писателю, который пропал в&nbsp;этой
          местности более 10&nbsp;лет назад.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Поиграть в&nbsp;Alan Wake 2&nbsp;можно на&nbsp;ПК, PlayStation 5, Xbox Series X|S</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Hi-Fi Rush
        </Heading>
        <Text color="white">
          Лучшие игры&nbsp;&mdash; это не&nbsp;всегда про монстров, вселенские заговоры и&nbsp;кровавые сражения. Порой
          это что-то лёгкое, красочное&nbsp;и, как&nbsp;бы неожиданно ни&nbsp;прозвучало, музыкальное! Именно так можно
          охарактеризовать Hi-Fi Rush&nbsp;&mdash; игру, визуально напоминающую мультфильм в&nbsp;стиле комиксов.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Главный герой&nbsp;&mdash; мальчик Чай. Он&nbsp;так искренне мечтал стать музыкантом, что обстоятельства
          встали на&nbsp;его сторону&nbsp;&mdash; теперь у&nbsp;героя в&nbsp;груди вместо сердца &laquo;бьется&raquo;
          музыкальный плеер. Он&nbsp;тонко чувствует все ритмы окружающего мира и&nbsp;устремляется навстречу
          приключениям. На&nbsp;нём лежит важная миссия: спасти планету и&nbsp;стать рок-звездой.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Все атаки в&nbsp;игре построены на&nbsp;ритме. Враги нападают в&nbsp;такт саундтреку, и&nbsp;вы&nbsp;должны
          отбивать удары в&nbsp;том&nbsp;же темпе.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          На&nbsp;этот раз ничего серьёзного&nbsp;&mdash; просто весёлая забава на&nbsp;несколько вечеров, но,
          безусловно, креативная и&nbsp;притягательная.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Играем на&nbsp;PlayStation 5, Xbox Series X|S, Xbox Cloud Gaming, Windows</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Marvel’s Spider-Man 2
        </Heading>
        <Text color="white">
          Моральное падение Питера Паркера, внутренние сомнения Майлза Моралеса, полеты с&nbsp;веб-крыльями
          на&nbsp;паутине,&nbsp;&mdash; вот далеко не&nbsp;полный список того, что ждёт вас в&nbsp;новой части
          &laquo;Человека-Паука&raquo;. А&nbsp;ещё играть вы&nbsp;будете сразу за&nbsp;двух пауков. Питер и&nbsp;Майлз
          одинаково хороши в&nbsp;бою, но&nbsp;у&nbsp;каждого из&nbsp;них свои способности. У&nbsp;Питера есть
          металлические щупальца, а&nbsp;Майлз владеет искусством электрических атак и&nbsp;может становиться невидимым.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Во&nbsp;второй версии боевой арсенал стал более разнообразным, локации&nbsp;&mdash; более проработанными,
          второстепенные задания&nbsp;&mdash; интересными и&nbsp;значимыми.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Игра определённо понравится молодому поколению и&nbsp;почти точно тем, кто молод душой и&nbsp;не&nbsp;ищет
          квесты со&nbsp;слишком замысловатым сюжетом.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Официальный релиз был только для PlayStation&nbsp;5, позже игру добавили в&nbsp;Steam</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Star Wars Jedi: Survivor
        </Heading>
        <Text color="white">
          Помните джедая, выжившего после уничтожения ордена? Его приключения продолжаются. Теперь у&nbsp;героя есть
          не&nbsp;два, а&nbsp;целых пять видов оружия, а&nbsp;значит сражения будут ещё более впечатляющими. Вместе
          с&nbsp;игровым персонажем вы&nbsp;побываете на&nbsp;шести планетах, сразитесь с&nbsp;имперскими солдатами,
          дроидами, агрессивными зверями. Парируйте и&nbsp;уворачивайтесь&nbsp;&mdash; только не&nbsp;сдавайтесь!
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Игра определенно заслуживает место в&nbsp;нашем топе, хоть и&nbsp;получает неоднозначные отзывы. Кто-то
          испытывает технические сложности при запуске, торможение и&nbsp;&laquo;подвисание&raquo;, другие говорят
          о&nbsp;том, что проблема уже решена. Все сходятся в&nbsp;том, что история получилась захватывающей,
          харизматичной и&nbsp;с&nbsp;достаточно очевидным потенциалом для триквела.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Доступен для Windows, PlayStation 5&nbsp;и&nbsp;Xbox Series X/S</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Hogwarts Legacy
        </Heading>
        <Text color="white">
          &laquo;Добро пожаловать в&nbsp;Хогвартс!&raquo;&nbsp;&mdash; первое, что хочется сказать об&nbsp;этой игре.
          Перед нами увлекательное виртуальное путешествие по&nbsp;множеству легендарных локаций. Все они продуманы
          очень тонко, с&nbsp;большой любовью и&nbsp;вниманием к&nbsp;деталям. Вы&nbsp;сможете полетать на&nbsp;метле,
          разучить парочку заклинаний, погреть ноги у&nbsp;камина и&nbsp;даже получить волшебную палочку. Стоит
          отметить, что эта экшен-RPG новинка была одной из&nbsp;самых ожидаемых, и&nbsp;ожидания оправдались.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Отсылка к&nbsp;миру, созданному Джоан Роулинг, изначально была беспроигрышной стратегией,
          но&nbsp;и&nbsp;реализация не&nbsp;подкачала. В&nbsp;виртуальной вселенной Hogwarts Legacy приятно находиться,
          интересно смотреть по&nbsp;сторонам и&nbsp;просто наслаждаться качеством графики. А&nbsp;если добавить
          к&nbsp;этому тот факт, что главный герой ведет праведную битву добра со&nbsp;злом, то&nbsp;сомнений
          не&nbsp;остается&nbsp;&mdash; играть нужно.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Делать это вы&nbsp;можете на&nbsp;ПК, PlayStation 5, PlayStation 4, Xbox Series X|S, Xbox One, Nintendo Switch
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Street Fighter 6
        </Heading>
        <Text color="white">
          Street Fighter 6&nbsp;&mdash; захватывающий файтинг, детально проработанный и&nbsp;не&nbsp;надоедающий.
          Сюжетной линии хватит на&nbsp;много часов игры. Разработчики не&nbsp;поскупились на&nbsp;контент. Его
          много&nbsp;&mdash; так много, что будет интересно и&nbsp;&laquo;ветеранам&raquo;, и&nbsp;новичкам. Даже если
          это ваш дебют в&nbsp;файтингах, будет понятно и&nbsp;не&nbsp;очень сложно. В&nbsp;этом особенность игры.
          В&nbsp;ней много возможностей для обучения.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          На&nbsp;старте вам нужно создать собственного персонажа. Эта часть впечатляет уровнем проработки. Каждый
          персонаж описан в&nbsp;деталях, указано, в&nbsp;чём он&nbsp;хорош, а&nbsp;для каких сценариев не&nbsp;стоит
          выбирать его.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Вместе со&nbsp;своим героем вы&nbsp;отправитесь в&nbsp;Метро-Сити, где Люк научит вас боевым искусствам.
          Здесь&nbsp;же вы&nbsp;будете получать основные и&nbsp;вспомогательные задания, совершенствовать навыки
          и&nbsp;зарабатывать ценные предметы. Можно также переключаться на&nbsp;классические мультиплеерные или
          аркадные сражения.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Пользователи отмечают высококлассное звуковое оформление&nbsp;&mdash; от&nbsp;фоновой музыки до&nbsp;озвучки
          персонажей.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Поиграть можно на&nbsp;PlayStation 4, PlayStation 5&nbsp;и&nbsp;Xbox Series X/S и&nbsp;в&nbsp;Стиме
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Cocoon
        </Heading>
        <Text color="white">
          Если&nbsp;бы вы&nbsp;были насекомым, то&nbsp;каким? Не&nbsp;спешите отвечать, просто попробуйте себя
          в&nbsp;этой роли&nbsp;&mdash; разработчики Cocoon дают такую возможность. Знаем, звучит необычно и&nbsp;даже
          странно, но&nbsp;только на&nbsp;словах. На&nbsp;деле все очень даже увлекательно. Перед нами, пожалуй, одна
          из&nbsp;лучших логических головоломок последнего времени. Она изящная, причудливая, небанальная.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Приготовьтесь к&nbsp;тому, что в&nbsp;ней вашему персонажу придется все время думать и&nbsp;двигаться,
          двигаться и&nbsp;думать, а&nbsp;персонажем этим будет непонятное насекомое, похожее на&nbsp;мотылька. Оно
          только вылупилось из&nbsp;кокона и&nbsp;тут&nbsp;же попало в&nbsp;таинственный мир,
          а&nbsp;из&nbsp;него&nbsp;&mdash; в&nbsp;другой, в&nbsp;третий, четвертый...
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Вы&nbsp;будете проходить головоломку за&nbsp;головоломкой, пока не&nbsp;выведете свои нейронные связи
          на&nbsp;внеземной уровень.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Игра оформлена минималистично. В&nbsp;ней нет ничего лишнего, все предметы, которые вы&nbsp;видите, имеют
          значение. Этот принцип минимализма перенесен и&nbsp;на&nbsp;управление&nbsp;&mdash; для выполнения действия
          достаточно всего одного нажатия на&nbsp;кнопку. Такая лаконичность вовсе не&nbsp;означает недоработки
          со&nbsp;стороны разработчиков. Совсем нет. Графика проработана очень хорошо. Просто она
          своеобразная&nbsp;&mdash; местами непонятная, порой слишком креативная, но&nbsp;точно цепляющая внимание.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          На&nbsp;прохождение игры понадобится около пяти часов. Отправиться в&nbsp;увлекательное путешествие можно
          вместе со&nbsp;Steam и&nbsp;Microsoft Store на&nbsp;ПК, PlayStation 4&nbsp;и&nbsp;5, Xbox One и&nbsp;Xbox
          Series.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          The Invincible
        </Heading>
        <Text color="white">
          Персонажи, космические корабли и&nbsp;декорации этой игры словно сошли с&nbsp;обложек журналов о&nbsp;научной
          фантастике прошлого столетия. И&nbsp;здесь нет намека на&nbsp;устарелость или неактуальность. Совсем наоборот.
          Это про стилизацию и&nbsp;качественную реализацию идеи.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Игра The Invincible вдохновлена романом &laquo;Непобедимый&raquo;. И&nbsp;вроде&nbsp;бы в&nbsp;ней нет прямых
          совпадений с&nbsp;персонажами Станислава Лема, но&nbsp;сама сюжетная идея прослеживается очень выразительно.
          Создателям удалось мастерски перенести её&nbsp;с&nbsp;бумаги на&nbsp;экран.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          События разворачиваются вокруг астробиолога по&nbsp;имени Ясна. Она просыпается на&nbsp;планете Регис III
          и&nbsp;совершенно ничего не&nbsp;помнит о&nbsp;своём прошлом. А&nbsp;значит, вам вместе с&nbsp;ней придется
          выяснить, что произошло.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Забегая вперед, скажем, что память постепенно возвращается, но&nbsp;это совсем не&nbsp;означает, что ваша
          миссия завершена. Ясна вспоминает, что экипаж её&nbsp;научного корабля пропал, а&nbsp;значит, у&nbsp;вас
          появляется новая миссия&nbsp;&mdash; отыскать его.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Подходит для Windows, PlayStation 5&nbsp;и&nbsp;Xbox Series X/S</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Alone in the Dark
        </Heading>
        <Text color="white">
          Перед нами психологический хоррор. Как правило, такое определение жанру дают, когда &laquo;ужастик&raquo;
          получается недостаточно страшным, чтобы стать уверенным хоррором, но&nbsp;в&nbsp;то&nbsp;же время
          он&nbsp;не&nbsp;лишен леденящих душу сцен. Это вполне справедливо для Alone in&nbsp;the Dark. В&nbsp;начале
          игры вам может быть по-настоящему страшно, но&nbsp;постепенно становится спокойнее, напряжение тает
          на&nbsp;глазах и&nbsp;лишь время от&nbsp;времени сердце начинает биться учащённо. Хорошо это или плохо? Скажем
          так&nbsp;&mdash; это комфортно.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Теперь немного о&nbsp;сюжете. Действия разворачиваются в&nbsp;лечебнице Дерсето. Один
          из&nbsp;её&nbsp;постояльцев пишет письма о&nbsp;чудовищных вещах, которые происходят в&nbsp;стенах больницы.
          Расследовать происшествия приезжают племянница пациента и&nbsp;детектив Эдвард Карнби. Не&nbsp;будем
          рассказывать, что ждет героев, отметим лишь, что придётся и&nbsp;сражаться, и&nbsp;головоломки разгадывать.
          Не&nbsp;беспокойтесь, слишком сложно не&nbsp;будет (и&nbsp;слишком страшно тоже&nbsp;&mdash;
          мы&nbsp;с&nbsp;этого начинали). Игра достаточно плавная.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Запускается в&nbsp;Стим, на&nbsp;PlayStation 5&nbsp;и&nbsp;Xbox Series</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Dead Space
        </Heading>
        <Text color="white">
          Посвящается любителям космических хорроров. Это отличный ремейк, который объединил и&nbsp;преумножил всё
          лучшее, что было в&nbsp;Dead Space и&nbsp;Dead Space&nbsp;2, оставив в&nbsp;прошлом технические несовершенства
          и&nbsp;то, что давно утратило актуальность. Получилось весьма неплохо&nbsp;&mdash; ожидания геймеров
          оправдались, а&nbsp;это крутой показатель, ведь целевая аудитория привыкла к&nbsp;зрелищным
          и&nbsp;эмоциональным играм и&nbsp;не&nbsp;согласилась&nbsp;бы на&nbsp;меньшее.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Изменения затронули корабль &laquo;Ишимура&raquo;&nbsp;&mdash; он&nbsp;стал больше и&nbsp;детализированнее.
          Появились случайные события, которые не&nbsp;дают расслабиться, а&nbsp;уж&nbsp;тем более заскучать. Теперь
          система расставляет врагов и&nbsp;ресурсы в&nbsp;произвольном порядке, что подогревает интерес
          и&nbsp;мотивирует быть в&nbsp;тонусе.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Что касается сюжета, то&nbsp;студия EA&nbsp;Motive очень бережно проработала оригинал, чтобы сохранить его
          неповторимую аутентичность и&nbsp;в&nbsp;то&nbsp;же время &laquo;осовременить&raquo;. События разворачиваются
          в&nbsp;далеком будущем. Космический корабль подает сигнал &laquo;СОС&raquo;, на&nbsp;который реагирует
          ремонтная бригада. Прибывая на&nbsp;место, ремонтники становятся жертвами мутировавших трупов прежних жителей
          корабля.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Главная миссия&nbsp;&mdash; помочь инженеру Айзеку Кларку найти его девушку Николь и&nbsp;вернуть героев
          домой.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Запускается в&nbsp;Steam и&nbsp;на&nbsp;приставках PlayStation и&nbsp;Xbox</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Dredge
        </Heading>
        <Text color="white">
          Dredge&nbsp;&mdash; игра, в&nbsp;которой нет случайностей. У&nbsp;всего происходящего здесь есть смысл. Вам
          нужно быть внимательным, и&nbsp;собирать все события как пазлы, чтобы увидеть целостную историю. Согласитесь,
          звучит как детектив, и&nbsp;что-то от&nbsp;детектива определённо есть в&nbsp;этой игре, хотя на&nbsp;самом
          деле перед нами симулятор морской рыбалки в&nbsp;стиле хоррор.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Имеем дело с&nbsp;дебютным лаконичным релизом новозеландской компании. Сюжет в&nbsp;этой игре пусть
          и&nbsp;не&nbsp;шедевральный, но&nbsp;весьма неплохой, а&nbsp;игровой дизайн&nbsp;&mdash; просто великолепный.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Радует и&nbsp;сама задумка. Казалось&nbsp;бы, что страшного может быть в&nbsp;рыбалке? Ответ на&nbsp;этот
          вопрос знает главный игровой персонаж. По&nbsp;сценарию, он&nbsp;прибывает в&nbsp;удаленный портовый городок,
          чтобы работать там рыбаком. С&nbsp;утра он&nbsp;выходит в&nbsp;море, расставляет сети и&nbsp;ловит рыбу,
          а&nbsp;вечером продает её&nbsp;в&nbsp;порту. Все&nbsp;бы ничего, вот только в&nbsp;его сети попадают страшные
          мутанты, его лодку грозит разбить гигантский осьминог, и&nbsp;это далеко не&nbsp;всё. Рассказывать
          в&nbsp;деталях не&nbsp;будем&nbsp;&mdash; так будет интереснее играть. На&nbsp;прохождение этого симулятора
          вам потребуется менее 20&nbsp;часов, дерзайте&nbsp;&mdash; игрушка есть в&nbsp;Steam.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Like a Dragon: Ishin!
        </Heading>
        <Text color="white">
          Следующей строкой в&nbsp;нашем топе лучших игр идет Like a&nbsp;Dragon: Ishin. Это ремейк сюжетного экшена
          о&nbsp;закате эпохи самураев от&nbsp;Sega, который был выпущен в&nbsp;2014&nbsp;году. Помимо насыщенного
          игрового сюжета здесь вас ждут красивые пейзажи старого Киото и&nbsp;зрелищные самурайские бои.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Кардинальных изменений в&nbsp;сюжетной линии не&nbsp;произошло. Из&nbsp;нового&nbsp;&mdash; улучшена графика,
          доработаны персонажи.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          События разворачиваются в&nbsp;Японии в&nbsp;60-х годах девятнадцатого столетия, когда страна находилась
          на&nbsp;грани войны с&nbsp;Западом. Правительство оказывается бессильным, народ требует вернуть власть
          императору&nbsp;&mdash; ещё немного и&nbsp;разгорится гражданская война. В&nbsp;это время в&nbsp;провинции
          Тоса происходит убийство. Жертва&nbsp;&mdash; чиновник-реформатор. Главный подозреваемый&nbsp;&mdash; его
          приёмный сын. Но&nbsp;молодой самурай невиновен, и&nbsp;единственный выход для него защитить своё достоинство
          и&nbsp;опровергнуть обвинения&nbsp;&mdash; найти настоящего убийцу.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Игра доступна в&nbsp;Steam на&nbsp;ПК, PlayStation 4&nbsp;и&nbsp;5, Xbox Series X|S, Xbox One
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Mortal Kombat 1
        </Heading>
        <Text color="white">
          Едва&nbsp;ли найдётся тот, кто никогда не&nbsp;слышал про Mortal Kombat, а&nbsp;если прежде вам
          не&nbsp;предоставлялся случай поиграть, то&nbsp;вот он&nbsp;знак&nbsp;&mdash; перезапуск легендарной серии.
          Нам с&nbsp;вами посчастливилось стать свидетелями начала новой эры культовой франшизы.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          В&nbsp;отличие от&nbsp;предыдущих версий, теперь можно поиграть не&nbsp;только за&nbsp;типовых бойцов,
          но&nbsp;и&nbsp;за&nbsp;Рептилию, Бараку, Милину, Шан Тсунга. В&nbsp;финальной главе разработчики предоставили
          нам возможность выбрать любого бойца.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          По&nbsp;сюжетной линии мнения разделились. Кто-то находит её&nbsp;мелкой и&nbsp;даже странной, а&nbsp;кто-то
          просто наслаждается процессом, вспоминая старые добрые времена с&nbsp;Mortal Kombat. Что касается технической
          составляющей, то&nbsp;особых расхождений в&nbsp;оценках нет. Графика, озвучка персонажей, музыкальное
          сопровождение,&nbsp;&mdash; всё качественное, продуманное современное.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Игра зрелищная, стабильная, местами даже захватывающая. Как минимум, пару-тройку вечеров стоит выделить для
          неё, а&nbsp;дальше&nbsp;&mdash; как пойдет.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Играть можно на&nbsp;ПК, PlayStation 5, Xbox Series X|S, Nintendo Switch.</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          System Shock
        </Heading>
        <Text color="white">
          Ремейка System Shock ждали очень долго. Так долго, что понемногу стали забывать, но&nbsp;новинка вышла,
          и&nbsp;не&nbsp;разочаровала. Как и&nbsp;предшественник 1994&nbsp;года, она погружает в&nbsp;очень приятную
          атмосферу, радует качественной и&nbsp;эстетичной ретрографикой. Интерфейс игры минималистичный, управление
          отзывчивое&nbsp;&mdash; всё понятно и&nbsp;тем, кто знаком с&nbsp;классикой, и&nbsp;тем, кто впервые
          усаживается перед монитором, чтобы пройти незнакомый до&nbsp;настоящего момента киберпанк-хоррор.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          События разворачиваются на&nbsp;заброшенной станции. На&nbsp;календаре 2072&nbsp;год. Неизвестный хакер хочет
          украсть ценные данные корпорации TriOptimum, но&nbsp;его ловят на&nbsp;горячем и&nbsp;предлагают сделку.
          Он&nbsp;должен отправиться на&nbsp;космическую станцию &laquo;Цитадель&raquo;, чтобы усовершенствовать
          искусственный интеллект SHODAN. Взамен он&nbsp;получит освобождение от&nbsp;тюрьмы и&nbsp;военный
          нейроимплант.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Хакеру удается выполнить все условия сделки. Он&nbsp;получает награду и&nbsp;ждет, пока нейроимплант
          приживётся. Проходит полгода. Герой просыпается и&nbsp;видит, что весь экипаж &laquo;Цитадели&raquo; погиб,
          а&nbsp;вместо него по&nbsp;космической станции разгуливают киборги и&nbsp;мутанты. Это дело рук SHODAN,
          и&nbsp;теперь&nbsp;ИИ планирует уничтожить Землю. Способен&nbsp;ли главный герой нарушить эти планы
          и&nbsp;спасти мир?
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Поиграйте в&nbsp;Steam или на&nbsp;топовых приставках, чтобы узнать.</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Tekken 8
        </Heading>
        <Text color="white">
          Это новая часть одного из&nbsp;самых популярных трехмерных файтингов с&nbsp;30-летней историей. Её&nbsp;выхода
          поклонники ждали около семи лет.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Кадзуя Мисима утверждает свои правила мироздания, и&nbsp;противостоять ему может только его сын. Но, прежде
          чем вступить в&nbsp;поединок с&nbsp;отцом, Дзин Кадзама должен победить внутренних демонов.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Игра привлекает плавной и&nbsp;реалистичной анимацией. В&nbsp;новой части появилась система Heat, которая
          усиливает героя и&nbsp;расширяет игровые возможности. Вы&nbsp;можете пробивать оборону, сокращать дистанцию,
          продлевать комбо. С&nbsp;новым режимом давно знакомый файтинг становится непредсказуемым и&nbsp;зрелищным.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Ещё одно нововведение&nbsp;&mdash; возможность восстанавливать здоровье. Чтобы сделать это, вам нужно
          атаковать врага.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Игра получилась динамичной. Кажется, стандартные правила больше не&nbsp;работают. В&nbsp;любой момент могут
          появиться новые способности. Локации и&nbsp;условия постоянно меняются, так что вам не&nbsp;надоест.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Играть можно Steam и&nbsp;Microsoft Store на&nbsp;ПК, PlayStation 4&nbsp;и&nbsp;5, Xbox One и&nbsp;Series
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Banishers: Ghosts of New Eden
        </Heading>
        <Text color="white">
          Антея Дуарте и&nbsp;Ред Макрейф&nbsp;&mdash; спутники в&nbsp;жизни и&nbsp;в&nbsp;работе. Они спасают мир
          от&nbsp;злых духов. На&nbsp;очередном задании Антея погибает и&nbsp;превращается в&nbsp;призрака. Теперь
          её&nbsp;возлюбленному придется разгадать тайну проклятия и&nbsp;спасти Антею. Но&nbsp;как быть, если для этого
          необходимо забирать души у&nbsp;живых людей? Оправдана&nbsp;ли такая жертва во&nbsp;имя спасения главной
          героини?
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          На&nbsp;протяжении всей игры герои сталкиваются с&nbsp;выбором: обвинить человека или изгнать призрака;
          разговаривать с&nbsp;нечистью или сражаться.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Разработчики предусмотрели возможность переключать игровых персонажей между Антеей и&nbsp;Редом, чтобы
          использовать уникальные способности каждого.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Игра получилась динамичной и&nbsp;захватывающей, что позволило включить ее&nbsp;в&nbsp;список лучших
          экшенов-RPG от&nbsp;третьего лица. Пользователи отмечают отличную озвучку, интересный основной сюжет
          и&nbsp;красивую картину взаимоотношений между влюбленными экзорцистами.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Игра разработана для Windows, PlayStation 5, Xbox Series X/S</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Cyberpunk 2077: Phantom Liberty
        </Heading>
        <Text color="white">
          Вы, как главный игровой персонаж, становитесь наемником и&nbsp;получаете задание украсть нейрочип
          у&nbsp;корпорации &laquo;Арасака&raquo;. В&nbsp;какой-то момент все пошло не&nbsp;по&nbsp;плану,
          и&nbsp;в&nbsp;вашей голове прочно засел призрак мертвого рок-музыканта Джонни Сильверхэнда. Как видите,
          сюжетная линия не&nbsp;изменилась. При этом игра стала более сложной, проработанной и&nbsp;динамичной.
          Постоянно меняется темп: тут вы&nbsp;плавно перемещаетесь, не&nbsp;привлекая к&nbsp;себе лишнего внимания,
          а&nbsp;спустя совсем немного времени вступаете в&nbsp;масштабную перестрелку. Такая смена событий поддерживает
          интерес&nbsp;&mdash; игра не&nbsp;надоедает.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Положительный эффект усиливает реалистичность героев. Даже будучи профессиональными шпионами, они остаются
          обычными людьми, с&nbsp;различными недостатками и&nbsp;слабостями. Это сближает.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          По&nbsp;заявлениям разработчиков, Cyberpunk 2077: Phantom Liberty стала завершающей частью легендарной игры.
          Продолжения игрового контента ожидать не&nbsp;стоит.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Играем на&nbsp;PlayStation 5, Xbox Series X|S, Windows</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Warhammer 40,000: Boltgun
        </Heading>
        <Text color="white">
          Перед нами типичный ретрошутер в&nbsp;духе Doom. Сюжетная линия этой игры уводит нас в&nbsp;далёкое будущее.
          События разворачиваются в&nbsp;мире, где идет война. Эта страшная всепоглощающая сила сметает все
          на&nbsp;своем пути. Инквизиция даёт задание десантнику из&nbsp;Ордена ультрамаринов отправиться
          на&nbsp;мир-кузницу Грайю, где проводятся эксперименты над источником силы покойного Дрогана. На&nbsp;земле
          царит хаос, и&nbsp;только главный герой может победить его. Ему предстоит уничтожить зло и&nbsp;вернуть
          источник силы.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Не&nbsp;хотим вас пугать, но&nbsp;считаем нужным предупредить, что игра непростая. Несмотря на&nbsp;то, что
          сложность идёт по&nbsp;нарастающей от&nbsp;уровня к&nbsp;уровню, даже на&nbsp;начальных этапах бывает
          нелегко&nbsp;&mdash; но&nbsp;интересно. Кажется, будто враги становятся все сильнее, а&nbsp;в&nbsp;вашем
          арсенале не&nbsp;появляются новые средства противостояния. Выход есть. Конечно, мы&nbsp;не&nbsp;будем давать
          подсказки, а&nbsp;предложим вам пройти игру самостоятельно&nbsp;&mdash; так интереснее.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Warhammer&nbsp;40,000: Boltgun красиво стилизована под классику. В&nbsp;ней разворачиваются динамичные
          сражения, враги не&nbsp;дают права на&nbsp;ошибку. Атмосфера, сюжет, саундтреки,&nbsp;&mdash; все подобрано
          так, чтобы создать особый антураж.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Попробовать себя можно на&nbsp;PlayStation 5, Xbox Series X|S, Windows</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Играйте в&nbsp;Steam в&nbsp;2024 году без ограничений!
        </Heading>
        <Text color="white">
          Все топовые игры разработчики добавляют в&nbsp;Steam&nbsp;&mdash; это игровая платформа, которая даёт доступ
          к&nbsp;самым трендовым новинкам и&nbsp;любимой классике игр на&nbsp;ПК. Не&nbsp;надо покупать приставки или
          диски&nbsp;&mdash; в&nbsp;Стиме игры, как правило, стоят дешевле, а&nbsp;играть в&nbsp;них интереснее
          за&nbsp;счёт возможности сразу&nbsp;же обсуждать результаты с&nbsp;игровым сообществом, быстро находить
          подсказки, делиться мнением, покупать улучшения.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Пополнить игровой кошелек в&nbsp;Стим с&nbsp;2024 году со&nbsp;своей банковской карты с&nbsp;низкой комиссией
          по&nbsp;СБП поможет сервис <NewCardLink href={STEAM_URL}>МТС&nbsp;Оплата</NewCardLink>. Выберите вариант
          пополнения и&nbsp;следуйте подсказкам системы&nbsp;&mdash; средства будут зачислены в&nbsp;срок
          от&nbsp;15&nbsp;минут. Пополнить кошелек в&nbsp;Стиме можно с&nbsp;карты любого банка. Максимальный срок
          зачисления&nbsp;&mdash; 2&nbsp;часа.
        </Text>
      </>,
    date: '23.05.2024',
    imagePage: top20,
    imageSlide: top20Slide,
    titleMeta: 'ТОП-20 лучших игр для ПК — рейтинг компьютерных игры по версии пользователей',
    descriptionMeta: 'ТОП-20 лучших игр для ПК ► Подборка игр для компьютера ► Во что поиграть в свободное время ► Системные требования, отзывами и оценки игроков'
  },
  kak_pokupat_igry_v_steam: {
    id: 'kak_pokupat_igry_v_steam',
    title: 'Как покупать игры в\u00A0Steam в\u00A0России',
    describe: 'Пошаговая инструкция по обходу ограничений в 2024 году',
    describeFull: <>
        <Text color="white">
          Из-за региональных ограничений некоторые игры в&nbsp;Steam могут быть недоступны для пользователей
          из&nbsp;России. Мы&nbsp;проверили, как обойти ограничения и&nbsp;получить доступ к&nbsp;любому контенту
          в&nbsp;Стим. Также рассказываем, как сейчас можно пополнять игровой кошелёк в&nbsp;Steam.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Текущие ограничения для пользователей из&nbsp;России касаются сразу двух важных моментов: пополнения счёта
          игрового аккаунта и&nbsp;покупки игр в&nbsp;Steam. В&nbsp;настоящий момент для российских игроков недоступен
          новый контент таких издателей, как Electronic Arts, 2K&nbsp;Games, PlayStation, Activision, Ubisoft. Все
          старые покупки сохраняются в&nbsp;профиле, вы&nbsp;можете продолжать играть в&nbsp;эти игры как раньше.
          Будут&nbsp;ли новые ограничения&nbsp;&mdash; неизвестно.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Тем не&nbsp;менее, купить заблокированные для России игры в&nbsp;Стиме можно&nbsp;&mdash; рассказываем, как
          это сделать.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Сменить регион
        </Heading>
        <Text color="white">
          В&nbsp;интернет есть масса посредников, предлагающих помощь в&nbsp;переносе аккаунта. Более того, можно купить
          готовый аккаунт нужного региона. Это стоит недорого, но&nbsp;имеет определённые риски:
        </Text>
        <Spacer space={24} spacemob={16} />
        <WrapperList>
          <List data={[{
          id: 1,
          text: 'для переноса вашего профиля в\u00A0новый регион посредником вам придётся дать доступ к\u00A0личным данным;'
        }, {
          id: 2,
          text: 'при покупке готового аккаунта есть риск нарваться на\u00A0мошенников\u00A0— надо быть крайне осторожным и\u00A0выбирать продавца с\u00A0хорошими отзывами.'
        }]} bulletColorType="gray" size="md" sizemob="sm" />
        </WrapperList>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Чтобы избежать этих рисков, смените регион самостоятельно:</Text>
        <Spacer space={24} spacemob={16} />
        <Ol>
          <li>
            Используйте VPN. Выберите страну, в&nbsp;которую планируете &laquo;переехать&raquo;&nbsp;&mdash; оптимально,
            если это страны СНГ, например, Казахстан.
          </li>
          <li>В&nbsp;Steam Guard выйдите из&nbsp;аккаунта на&nbsp;всех подключенных устройствах.</li>
          <li>
            Войдите в&nbsp;свой профиль под VPN. Добавьте недорогую игру в&nbsp;корзину&nbsp;&mdash; её&nbsp;надо будет
            оплатить для подтверждения региона.
          </li>
          <li>
            Измените страну магазина в&nbsp;профиле. Steam считывает регион пользователя не&nbsp;только по&nbsp;метке
            локации и&nbsp;данным профиля, но&nbsp;и&nbsp;по&nbsp;данным банковской карты. Вам понадобится указать
            платёжные данные&nbsp;&mdash; адрес и&nbsp;телефон можно найти в&nbsp;сети (есть специальные сайты для
            подбора таких сведений). Карту для первой оплаты можно использовать виртуальную. Далее лучше пополнять
            игровой кошелёк другими способами.
          </li>
          <li>
            Оплатите игру. Возвращать её&nbsp;нельзя, так как вам нужны будут данные карты списания, а&nbsp;если это
            была предоплаченная виртуалка, которая уже деактивировалась, вас могут заблокировать. Поэтому первая покупка
            должна быть недорогой: если игра не&nbsp;нужна, денег не&nbsp;жалко.
          </li>
        </Ol>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Чтобы сменить регион в&nbsp;Steam, вашему аккаунту должно быть более 3&nbsp;месяцев и&nbsp;у&nbsp;него
          не&nbsp;должно быть ограничений (блокировок за&nbsp;нарушения правил сообщества). Менять регион можно
          не&nbsp;чаще, чем один раз в&nbsp;три месяца.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Играть под VPN после переноса профиля не&nbsp;обязательно. Сразу после переноса не&nbsp;стоит пополнять баланс
          подарочными картами&nbsp;&mdash; у&nbsp;них может быть другой регион, и&nbsp;профиль автоматически сменит
          &laquo;прописку&raquo;.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Пополнить игровой кошелёк
        </Heading>
        <Text color="white">
          Использовать виртуальные карты для регулярных покупок не&nbsp;рекомендуется. По&nbsp;отзывам пользователей,
          Steam активно блокирует аккаунты при оплате игр таким картами.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Если на&nbsp;балансе игрового кошелька есть средства, новые покупки будут оплачиваться именно с&nbsp;кошелька,
          и&nbsp;карта вам не&nbsp;понадобится. При &laquo;переезде&raquo; аккаунта валюта в&nbsp;кошельке автоматически
          конвертируется в&nbsp;валюту нового региона. Всё, что нужно&nbsp;&mdash; просто пополнить счёт. Вот как это
          можно сделать:
        </Text>
        <Spacer space={24} spacemob={16} />
        <Ol>
          <li>
            С&nbsp;помощью WebMoney. Это электронный кошелёк, который можно пополнить с&nbsp;российской банковской
            карты. Перевести в&nbsp;Стим можно только доллары&nbsp;&mdash; в&nbsp;системе вебмани это эквивалент WMZ.
            Если у&nbsp;вас нет кошелька WebMoney&nbsp;&mdash; скачайте приложение на&nbsp;смартфон и&nbsp;получите
            формальный аттестат (инструкция есть в&nbsp;самом сервисе, вам понадобится только ваш паспорт
            и&nbsp;несколько минут времени на&nbsp;заполнение предложенных форм). После этого вы&nbsp;сможете купить WMZ
            и&nbsp;перевести их&nbsp;на&nbsp;баланс своего игрового кошелька, выбрав способ пополнения на&nbsp;бирже
            Exchanger.Money.
          </li>
          <li>
            Банковской картой. Как мы&nbsp;сказали выше, виртуальные карты использовать слишком рискованно. Но&nbsp;если
            у&nbsp;вас есть физическая карта иностранного банка, можно пополнить&nbsp;ей. Главное, чтобы регион аккаунта
            и&nbsp;карты совпадал.
          </li>
          <li>
            Подарочной картой или кодом предоплаты. Их&nbsp;можно купить на&nbsp;маркетплейсах у&nbsp;посредников.
            Официально в&nbsp;РФ такие карты не&nbsp;продаются.
          </li>
        </Ol>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Также вы&nbsp;можете&nbsp;
          <NewCardLink href={STEAM_URL}>пополнить игровой кошелёк</NewCardLink>
          &nbsp;в&nbsp;Steam через МТС Оплату.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Это быстрый и&nbsp;удобный сервис, который поможет вам внести деньги на&nbsp;баланс аккаунта по&nbsp;СБП.
          Подойдёт карта любого российского банка, в&nbsp;том числе&nbsp;&mdash; кредитная.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          С&nbsp;помощью этого сервиса можно пополнить аккаунты пользователей из&nbsp;РФ и&nbsp;стран СНГ
          с&nbsp;комиссией до&nbsp;10%. Деньги зачисляются в&nbsp;течение 15&nbsp;минут. В&nbsp;редких
          случаях&nbsp;&mdash; до&nbsp;2&nbsp;часов. После пополнения кошелька вы&nbsp;сможете покупать любые игры
          в&nbsp;новом регионе, а&nbsp;играть в&nbsp;них&nbsp;&mdash; из&nbsp;России.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Купить игру
        </Heading>
        <Text color="white">
          После переноса профиля и&nbsp;пополнения баланса можно покупать игрушки, которые были недоступны пользователям
          Steam в&nbsp;России. Некоторые продолжают пользоваться VPN какое-то время, чтобы подтвердить новую страну.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Для снижения рисков блокировки аккаунта не&nbsp;рекомендуется совершать покупки в&nbsp;первые 3-4 дня после
          переноса профиля в&nbsp;другую страну, а&nbsp;также покупать несколько игр одновременно.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Ключи для игры в Steam
        </Heading>
        <Text color="white">
          Альтернативный способ обойти ограничения&nbsp;&mdash; купить ключ. Так называется код для активации игры,
          который можно купить на&nbsp;площадках для геймеров и&nbsp;на&nbsp;маркетплейсах. У&nbsp;игрушки в&nbsp;коде
          должна быть пометка&nbsp;&mdash; Global или Region Free. Это означает, что региональные ограничения
          на&nbsp;неё не&nbsp;распространяются, и&nbsp;вы&nbsp;можете играть в&nbsp;неё с&nbsp;российского аккаунта без
          его переноса.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Напоследок отметим, что у&nbsp;Steam достаточно жёсткая модерация, и&nbsp;при выявлении нарушений, а,
          например, покупка аккаунта&nbsp;&mdash; одно из&nbsp;них, вас могут заблокировать навсегда. Оплаченный контент
          и&nbsp;средства на&nbsp;кошельке при этом не&nbsp;возвращаются.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Чтобы не&nbsp;потерять раннее купленные игры, стоит завести второй профиль и&nbsp;использовать его для
          &laquo;переезда&raquo; и&nbsp;покупки недоступных в&nbsp;России игр для Steam.
        </Text>
      </>,
    date: '15.04.2024',
    imagePage: buySteam,
    imageSlide: buySteamSlide,
    titleMeta: 'Как покупать игры в Steam в России — пошаговая инструкция по обходу ограничений в 2024 году',
    descriptionMeta: 'Как приобрести игры в Steam недоступные в России ► Как пополнять кошелёк с любой банковской карты ► Инструкция как обойти ограничения в 2024 году'
  },
  region_v_steam: {
    id: 'region_v_steam',
    title: 'Как поменять регион в Steam',
    describe: 'Подробный гайд по изменению страны',
    describeFull: <>
        <Text color="white">
          Игры в&nbsp;Steam могут быть недоступны в&nbsp;отдельных регионах. Чтобы играть без ограничений&nbsp;&mdash;
          достаточно сменить регион пользователя в&nbsp;Steam. Мы&nbsp;узнали, как это сделать, и&nbsp;делимся гайдом
          с&nbsp;вами.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Steam&nbsp;&mdash; цифровая платформа компании Valve, которая даёт доступ к&nbsp;играм на&nbsp;ПК
          пользователям по&nbsp;всему миру. Это могут быть как эксклюзивы, выпущенные специально для этой платформы, так
          и&nbsp;хиты Xbox, PlayStation, Ubisoft и&nbsp;других. Ряд ограничений делает невозможным покупку игр
          и&nbsp;пополнение кошельков Стим пользователями из&nbsp;России. Обойти эти ограничения и&nbsp;сохранить доступ
          к&nbsp;любимому контенту позволяет смена региона в&nbsp;Steam.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Требования к&nbsp;аккаунту Steam для смены региона
        </Heading>
        <Text color="white">
          Менять принадлежность аккаунта к&nbsp;тому или иному региону разрешено по&nbsp;умолчанию. Пользователи меняют
          место жительства, путешествуют, и, чтобы избежать нежелательных блокировок доступа к&nbsp;играм или изменить
          способ пополнения кошелька, могут менять регион.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text>Если вы&nbsp;хотите изменить регион в&nbsp;Steam, необходимо выполнение трёх условий:</Text>
        <Spacer space={24} spacemob={16} />
        {/* <List
          data={[
            {
              elements: [
                {
                  id: 1,
                  sub_elements: [
                    {
                      id: 1,
                      text: 'Аккаунт должен быть старше 3\u00A0месяцев.',
                    },
                    {
                      id: 2,
                      text: 'Прошлая смена региона была не\u00A0менее, чем 3\u00A0месяца назад.',
                    },
                    {
                      id: 3,
                      text: 'Аккаунт не\u00A0ограничен платформой. Если вы\u00A0получили VAC-бан (за\u00A0использование читов), игровую блокировку (за\u00A0оскорбления, препятствия нормальной игре), блокировку обмена (за\u00A0обман пользователей при обмене скинами)\u00A0— сменить регион не\u00A0получится.',
                    },
                  ],
                },
              ],
            },
          ]}
          listType="ol"
          bulletColorType="gray"
          size="md"
          sizemob="sm"
         /> */}
        <Ol>
          <li>Аккаунт должен быть старше 3&nbsp;месяцев.</li>
          <li>Прошлая смена региона была не&nbsp;менее, чем 3&nbsp;месяца назад.</li>
          <li>
            Аккаунт не&nbsp;ограничен платформой. Если вы&nbsp;получили VAC-бан (за&nbsp;использование читов), игровую
            блокировку (за&nbsp;оскорбления, препятствия нормальной игре), блокировку обмена (за&nbsp;обман
            пользователей при обмене скинами)&nbsp;&mdash; сменить регион не&nbsp;получится.
          </li>
        </Ol>
        <Spacer space={32} spacemob={24} />
        <Text color="white">Если все нормально, можно приступать.</Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Самостоятельная смена региона Steam
        </Heading>
        <Text color="white">
          Тут все достаточно просто: необходимо заставить платформу думать, что вы&nbsp;находитесь в&nbsp;другом
          регионе&nbsp;&mdash; сделать это можно с&nbsp;помощью вашего телефона и&nbsp;VPN. При использовании приложения
          для смены&nbsp;IP выбирайте точку подключения вручную, чтобы вас случайно не&nbsp;перекинуло на&nbsp;другой
          регион.
        </Text>
        {/* <List
          data={[
            {
              elements: [
                {
                  id: 1,
                  sub_elements: [
                    {
                      id: 1,
                      text: 'Включите ВПН, выберите регион, зайдите в\u00A0Steam Guard на\u00A0телефоне и\u00A0выйдите из\u00A0приложения на\u00A0всех подключенных устройствах.',
                    },
                    {
                      id: 2,
                      text: 'Зайдите в\u00A0свой аккаунт под VPN, добавьте недорогую игру в\u00A0корзину',
                    },
                    {
                      id: 3,
                      text: 'Выберите новый регион\u00A0- это пункт «Изменить страну магазина» в\u00A0настройках аккаунта. Выбирайте ту\u00A0страну, игровые кошельки которой можно без проблем пополнить из\u00A0России (обычно выбирают Казахстан).',
                    },
                    {
                      id: 4,
                      text: 'Заполните платежные данные\u00A0- адрес и\u00A0телефон можно найти в\u00A0сети, для этого есть генераторы случайных данных. После этого надо вписать банковскую карту той\u00A0же страны, куда вы\u00A0переносите профиль. У\u00A0вас должен быть доступ к\u00A0ней, чтобы верифицировать транзакцию. Можно использовать виртуальную карту.',
                    },
                  ],
                },
              ],
            },
          ]}
          listType="ol"
          bulletColorType="gray"
          size="md"
          sizemob="sm"
         /> */}
        <Spacer space={24} spacemob={16} />
        <Ol>
          <li>
            Включите ВПН, выберите регион, зайдите в&nbsp;Steam Guard на&nbsp;телефоне и&nbsp;выйдите из&nbsp;приложения
            на&nbsp;всех подключенных устройствах.
          </li>
          <li>Зайдите в&nbsp;свой аккаунт под VPN, добавьте недорогую игру в&nbsp;корзину.</li>
          <li>
            Выберите новый регион&nbsp;&mdash; это пункт &laquo;Изменить страну магазина&raquo; в&nbsp;настройках
            аккаунта. Выбирайте ту&nbsp;страну, игровые кошельки которой можно без проблем пополнить из&nbsp;России
            (обычно выбирают Казахстан).
          </li>
          <li>
            Заполните платежные данные — адрес и телефон можно найти в сети, для этого есть генераторы случайных данных.{' '}
            <span style={{
            color: 'red'
          }}>
              После этого надо вписать банковскую карту той же страны, куда вы переносите профиль. У вас должен быть
              доступ к ней, чтобы верифицировать транзакцию. Можно использовать виртуальную карту.
            </span>
          </li>
        </Ol>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Готово: ваш регион в&nbsp;Steam изменен. Для использования ресурса в&nbsp;дальнейшем VPN не&nbsp;нужен,
          пользоваться платформой можно как обычно. Все покупки, сделанные ранее, остаются доступны.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Приобретение готового аккаунта Steam
        </Heading>
        <Text color="white">
          Не&nbsp;самый безопасный, но&nbsp;более простой способ сменить страну магазина в&nbsp;Стим&nbsp;&mdash; это
          купить уже готовый профиль. Такие предложения есть и&nbsp;на&nbsp;игровых форумах, но&nbsp;прежде, чем
          переводить деньги, учтите следующие нюансы:
        </Text>
        <Spacer space={24} spacemob={16} />
        <Ol>
          <li>
            Возможность пополнения кошелька в&nbsp;Стим. Просто пополнить счёта пользователей Турции и&nbsp;Казахстана.
            Европа&nbsp;&mdash; сложнее.
          </li>
          <li>
            Отзывы о&nbsp;продавце&nbsp;&mdash; ищите человека с&nbsp;большим количеством закрытых сделок
            и&nbsp;положительным рейтингом. Не&nbsp;поленитесь поискать отзывы на&nbsp;альтернативных сайтах,
            а&nbsp;не&nbsp;только на&nbsp;том, где покупаете акк.
          </li>
          <li>
            Не&nbsp;забывайте, что продажа аккаунта в&nbsp;Steam нарушает правила сообщества. Дарить и&nbsp;обменивать
            их&nbsp;тоже нельзя. При обнаружении проданных аккаунтов их&nbsp;блокируют навсегда.
          </li>
        </Ol>
        <Spacer space={32} spacemob={24} />
        <Image priority src={regionSteamIn} width={1008} height={576} />
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Сам аккаунт стоит недорого, но&nbsp;потерять оплаченные игры будет обидно. Снизить вероятность блокировки
          поможет соблюдение некоторых правил:
        </Text>
        <Spacer space={24} spacemob={16} />
        <WrapperList>
          <List data={[{
          id: 1,
          text: 'при первом входе и\u00A0первой покупке рекомендуется использовать VPN с\u00A0меткой той страны, в\u00A0которую перенесен профиль;'
        }, {
          id: 2,
          text: 'при первом пополнении игрового кошелька не\u00A0надо использовать электронные подарочные карты Steam\u00A0- это может привести к\u00A0смене региона.'
        }]} bulletColorType="gray" size="md" sizemob="sm" />
        </WrapperList>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Риски при смене страны в&nbsp;Steam
        </Heading>
        <Text color="white">
          Если речь о&nbsp;покупке готового аккаунта, риск только один: нарваться на&nbsp;мошенников. Используйте
          торговые площадки с&nbsp;модерацией и&nbsp;не&nbsp;забудьте сменить пароль, почту и&nbsp;настроить Steam
          Guard.
        </Text>
        <Text>Если вы&nbsp;хотите изменить регион в&nbsp;Steam, необходимо выполнение трёх условий:</Text>
        <Spacer space={24} spacemob={16} />
        <WrapperList>
          <List data={[{
          id: 1,
          text: 'первую покупку желательно совершить не\u00A0ранее, чем через 3-5\u00A0дней;'
        }, {
          id: 2,
          text: 'покупать игры лучше со\u00A0своего игрового кошелька, а\u00A0не\u00A0с\u00A0виртуальной карты (как его пополнить\u00A0- расскажем ниже).'
        }]} bulletColorType="gray" size="md" sizemob="sm" />
        </WrapperList>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Могут&nbsp;ли забанить при смене региона в&nbsp;Стим?
        </Heading>
        <Text color="white">
          В&nbsp;теории, да, такие риски есть. Но&nbsp;если у&nbsp;вас не&nbsp;новый аккаунт, у&nbsp;вас не&nbsp;было
          нарушений, и&nbsp;это первая блокировка, её&nbsp;можно оспорить&nbsp;&mdash; скорее всего, бан снимут. Если
          бан повторный&nbsp;&mdash; шансов нет.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Чтобы не&nbsp;рисковать ранее купленными играми, можно оформить дополнительный аккаунт (потребуется
          альтернативный номер телефона и&nbsp;почта) и&nbsp;менять регион для него. Если потеряете&nbsp;&mdash;
          то&nbsp;немного. Также не&nbsp;совершайте массовых и&nbsp;дорогих покупок сразу, если заблокируют,
          вы&nbsp;потеряете всё&nbsp;&mdash; игры, инвентарь, средства на&nbsp;кошельке.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Как пополнить баланс в&nbsp;Steam после смены региона
        </Heading>
        <Text color="white">Есть несколько способов:</Text>
        <Spacer space={24} spacemob={16} />
        <Ol>
          <li>
            Электронные кошельки. Это работает для разных регионов, но&nbsp;есть минус&nbsp;&mdash; высокая комиссия
            системы.
          </li>
          <li>
            Карта друга. Человек, у&nbsp;которого есть банковская карта нужной страны, может пополнить ваш счёт
            в&nbsp;Стим за&nbsp;вас. Вопрос&nbsp;&mdash; есть&nbsp;ли такой человек.
          </li>
          <li>
            Подарочные карты. Их&nbsp;можно купить на&nbsp;российских маркетплейсах. Главное, не&nbsp;перепутать страну.
          </li>
          <li>
            Пополнение скинами. Если у&nbsp;вас есть ненужные скины, их&nbsp;можно продать, чтобы получить деньги
            на&nbsp;новую игру.
          </li>
        </Ol>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Но&nbsp;есть способ лучше&nbsp;&mdash;&nbsp;
          <NewCardLink href={STEAM_URL}>пополнение игровых кошельков Steam с&nbsp;МТС Оплата</NewCardLink>
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Сервис позволяет пополнить игровой кошелек по&nbsp;СБП, для этого необязательно быть клиентом МТС Банка,
          достаточно иметь любую карту платёжной системы &laquo;Мир&raquo;.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Возможна оплата дебетовыми и&nbsp;кредитными картами&nbsp;&mdash; просто укажите логин в&nbsp;Steam
          и&nbsp;пополните кошелек на&nbsp;нужную сумму. Сервис позволяет пополнять игровые счета пользователей&nbsp;РФ
          и&nbsp;стран СНГ. Комиссия за&nbsp;конвертацию&nbsp;&mdash; до&nbsp;10%. Деньги поступят в&nbsp;течение
          15&nbsp;мин. В&nbsp;редких случаях&nbsp;&mdash; до&nbsp;2&nbsp;часов. Также вы&nbsp;можете купить ваучер для
          зачисления денег в&nbsp;игровой профиль пользователя из&nbsp;США.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Если вы&nbsp;ввели неверный логин, который не&nbsp;существует, средства не&nbsp;будут зачислены
          и&nbsp;вернутся на&nbsp;карту, с&nbsp;которой был выполнен платёж.
        </Text>
      </>,
    date: '11.04.2024',
    imagePage: regionSteam,
    imageSlide: regionSteamSlide,
    titleMeta: 'Как сменить регион аккаунта Steam — подробный гайд по изменению страны в Стим',
    descriptionMeta: 'Подробная инструкция как сменить регион аккаунта Steam ► Как обойти ограничения для получения игр недоступных в России ►Работает без обращения в техподдержку'
  },
  best_games: {
    id: 'best_games',
    title: 'Лучшие игры уходящего года',
    describe: 'Вспоминаем нашумевшие игровые релизы',
    describeFull: <>
        <Text color="white">
          Впереди Новый Год, а&nbsp;это значит, что пора вспомнить самое лучшее, что принес нам мир видеоигр
          за&nbsp;прошедшие 12 месяцев. Наша редакция выбрала 5&nbsp;самых новых, обсуждаемых и&nbsp;ожидаемых игр этого
          года.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Baldur&#39;s Gate III
        </Heading>
        <Text color="white">
          Игра вышла в&nbsp;августе и&nbsp;успела навести шум в&nbsp;Интернете: поклонники всей серии и&nbsp;те, кто
          впервые окунулся в&nbsp;мир Baldur&#39;s Gate наконец смогли оценить новую часть ролевой игры. Превзойдя
          многие новинки этого года, игра получила внушительную оценку в&nbsp;рейтинге Игромании (9,5/10)
          и&nbsp;абсолютную десятку на&nbsp;Steam.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Hogwarts Legacy
        </Heading>
        <Text color="white">
          Эта игра, пожалуй, была одним из&nbsp;самых ожидаемых релизов. Попасть в&nbsp;Хогвартс и&nbsp;совершить
          незабываемое приключение по&nbsp;волшебному миру являлось мечтой многих из&nbsp;нас, и&nbsp;в&nbsp;Hogwarts
          Legacy игрокам такая возможность предоставлена по&nbsp;максимуму. Не&nbsp;важно, играть на&nbsp;ПК или
          &laquo;плойке&raquo;&nbsp;&mdash; впечатления одинаково яркие.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Atomic Heart
        </Heading>
        <Text color="white">
          Шутер, события которого происходят в&nbsp;СССР из&nbsp;альтернативной вселенной, стал настоящим хитом
          2023&nbsp;года. Игра стала популярной за&nbsp;счет интересного сюжета, проработанным деталям и&nbsp;хорошему
          юмору. Атомное сердце не&nbsp;похоже ни&nbsp;на&nbsp;что другое&nbsp;&mdash; российская студия-разработчик
          Mundfish удивила весь мир и&nbsp;привлекла внимание миллионов людей к&nbsp;вымышленной истории
          о&nbsp;советском агенте разведки.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          Dead Space (2023)
        </Heading>
        <Text color="white">
          К&nbsp;списку необычных по&nbsp;своей атмосфере новинок в&nbsp;игровом мире можно смело причислить Dead Space:
          космический хоррор, являющийся ремейком на&nbsp;игру 2008&nbsp;года, рассказывает о&nbsp;ремонтной команде,
          прибывшей на&nbsp;сигнал SOS одного из&nbsp;кораблей, и&nbsp;пугающих открытиях, которые ее&nbsp;ожидают
          по&nbsp;прибытии.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Heading h={3} color="white">
          The Legend of Zelda: Tears of the Kingdom
        </Heading>
        <Text color="white">
          Nintendo порадовали аудиторию продолжением культовой серии игр. Приключения в&nbsp;открытом мире
          с&nbsp;широким игровым функционалом не&nbsp;оставят равнодушным даже самого искушенного игрока. Изобретать
          механизмы, сражаться с&nbsp;противниками и&nbsp;решать головоломки&nbsp;&mdash; то&nbsp;самое сочетание,
          которое удержит внимание на&nbsp;протяжение всей истории.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Уходящий год был щедрым на&nbsp;качественные и&nbsp;интересные новинки самых разных жанров,
          а&nbsp;мы&nbsp;со&nbsp;своей стороны выделили среди них самые необычные и&nbsp;долгожданные.
        </Text>
      </>,
    date: '30.12.2023',
    imagePage: bestGames,
    imageSlide: bestGamesSlide,
    titleMeta: 'Лучшие игры уходящего года – МТС Оплата',
    descriptionMeta: 'Подборка лучших игр 2023 года, 5 самых новых, обсуждаемых и ожидаемых игр этого года.'
  },
  steam_hits: {
    id: 'steam_hits',
    title: 'Хиты Steam: знакомое, новое и\u00A0любимое',
    describe: 'Лидеры продаж всех времен\u00A0- какие игры вошли в\u00A0топ любимчиков?',
    describeFull: <>
        <Text color="white">
          Платформа Steam имеет ассортимент более 12&nbsp;тысяч игр различных жанров и&nbsp;ценовой категории, однако
          есть топ 5 игр, которые стали настоящими бестселлерами.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Абсолютным лидером является Counter Strike&nbsp;2. Неудивительно, ведь сложно найти человека, который
          не&nbsp;пробовал играть в&nbsp;знаменитый шутер или не&nbsp;имеет заядлых игроков в&nbsp;своем окружении.
          Именно вторая часть игры, вышедшая еще в&nbsp;2012&nbsp;году, стала настоящим хитом в&nbsp;мире киберспорта,
          и&nbsp;почти каждый любитель соревновательной игры всегда находится в&nbsp;курсе последних событий CS&nbsp;2.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          На&nbsp;втором месте не&nbsp;менее известная Dota&nbsp;2. Активное фанатское сообщество и&nbsp;бесчисленное
          количество игровых часов продвигают ее&nbsp;в&nbsp;самый топ уже несколько лет. Как и&nbsp;вышеупомянутая
          CS&nbsp;2, игре исполнилось уже больше 10 лет, и&nbsp;ее&nbsp;можно скачать бесплатно, а&nbsp;вот
          на&nbsp;крутые &laquo;фичи&raquo; игроки готовы тратить сбережения: каждому хочется иметь бонусы, которые
          порой могут решить исход очередной схватки.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Третье место заняла новинка 2023 года Baldur&#39;s Gate&nbsp;3, взорвавшая все игровое сообщество. Игра уже
          набрала практически 450 тысяч крайне положительных оценок пользователей Steam. Произведя такой фурор, ролевая
          игра с приключенческим уклоном заняла место в&nbsp;сердцах многих игроманов.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Следующая игра получила свою особую популярность, вероятно, во&nbsp;время пандемии, ведь именно в&nbsp;это
          время PUBG: BATTLEGROUDS скрашивала карантинные будни. Еще одна стратегия с&nbsp;элементами выживания
          ворвалась в&nbsp;топ продаж и держит позицию уже на&nbsp;протяжении 5&nbsp;лет.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Завершает список RUST: снова выживание в&nbsp;тяжелых условиях и&nbsp;борьба за&nbsp;жизнь среди игроков. Игра
          является достойным представителем своего жанра, за&nbsp;что ее&nbsp;и&nbsp;полюбили игроки.
          К&nbsp;тому&nbsp;же к&nbsp;игре вышло много дополнений, что определенно делает процесс выживания более
          разнообразным.
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Вывод о&nbsp;топе продаж напрашивается сам: в&nbsp;мире видеоигр особенно ценятся жанры выживания, приключений
          и шутеров. Такие игры определенно захватывает все внимание игроков, заставляя запускать их&nbsp;заново.
          А&nbsp;насладиться любимыми играми или впервые их&nbsp;оценить поможет сервис МТС Оплата. С&nbsp;сервисом
          можно не&nbsp;только купить сами бестселлеры, но&nbsp;и&nbsp;дополнения к&nbsp;ним, а&nbsp;также полезные или
          редкие предметы внутри игр. МТС Оплата обеспечит безопасный способ приобрести любую из&nbsp;заинтересовавших
          видеоигр, поэтому не&nbsp;стоит медлить: скорее выбирайте игру и&nbsp;добавьте ее&nbsp;к&nbsp;себе
          в&nbsp;коллекцию вместе с&nbsp;МТС Оплатой!
        </Text>
      </>,
    date: '21.12.2023',
    imagePage: hitSteam,
    imageSlide: hitSteamSlide,
    titleMeta: 'Хиты Steam: знакомое, новое и любимое – МТС Оплата',
    descriptionMeta: 'Топ 5 игр, которые стали настоящими бестселлерами в steam - выбирайте игру и добавьте ее к себе в коллекцию вместе с МТС Оплатой!'
  },
  awards: {
    id: 'awards',
    title: 'Возвращение бестселлеров или обновленная классика?',
    describe: 'Игры: новые, нашумевшие, ожидаемые',
    describeFull: <>
        <Text color="white">
          Новости игровой индустрии не&nbsp;перестают удивлять: на&nbsp;первую половину декабря пришлось много важных
          событий в мире компьютерных игр. Одной из&nbsp;самых нашумевших новостей стала победа Baldur&#39;s Gate
          3&nbsp;на ежегодной премии The Game Awards, получив звание &laquo;Игра года&raquo;. Помимо победы в&nbsp;этой
          номинации, игра стала лучшей еще в&nbsp;пяти категориях. Из&nbsp;бестселлеров 2023 года однозначно выделяется
          Starfield, количество игроков которой превысило 10 миллионов человек. Отличный результат для игры, вышедшей
          всего 4&nbsp;месяца назад!
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Нельзя обойти стороной анонс новых игр: например, совсем скоро игроки смогут насладиться Prince
          of&nbsp;Persia: The Lost Crown. Релиз &laquo;Принца&raquo; состоится уже 18&nbsp;января. Самое громкое событие
          не&nbsp;только декабря, но&nbsp;и, пожалуй, всего 2023 года стал трейлер новой GTA&nbsp;VI, вышедший
          5&nbsp;декабря и&nbsp;побивший рекорды на&nbsp;YouTube: за&nbsp;3&nbsp;часа ролик набрал более 100 миллионов
          просмотров. Это неудивительно, ведь фанаты игры ждали продолжение целых 12&nbsp;лет! К сожалению для многих,
          игра будет выпущена только в&nbsp;2025&nbsp;году. Кажется, что в&nbsp;сравнении с&nbsp;ожиданием более десятка
          лет это кажется уже не&nbsp;таким значительным сроком, правда?
        </Text>
      </>,
    date: '18.12.2023',
    imagePage: awards,
    imageSlide: awardsSlide,
    titleMeta: 'Возвращение бестселлеров или обновленная классика? – МТС Оплата',
    descriptionMeta: 'Одной из самых нашумевших новостей стала победа Baldur\u0027s Gate 3 на ежегодной премии The Game Awards, получив звание «Игра года» - выбирайте игру и добавьте ее к себе в коллекцию вместе с МТС Оплатой!'
  },
  steam: {
    id: 'steam',
    title: 'Любимые игры по\u00A0спеццене!',
    describe: 'Как устроена распродажа в\u00A0Steam?',
    describeFull: <>
        <Text color="white">
          Погружаемся в&nbsp;мир компьютерных игр. Думаем, что игровую площадку Steam знают не&nbsp;только заядлые
          любители компьютерных игр, но&nbsp;и&nbsp;обычные пользователи интернета. Регулярно сервис устраивает
          распродажи и&nbsp;совсем скоро начнется одна из&nbsp;самых масштабных из&nbsp;них&nbsp;&mdash; зимняя
          распродажа. С&nbsp;21&nbsp;декабря по&nbsp;4&nbsp;января пользователи могут не только купить с&nbsp;большими
          скидками игры, которые давно хранятся в&nbsp;списке желаемых, но&nbsp;и&nbsp;поучаствовать в различных
          квестах. Призами станут уникальные предметы и&nbsp;значки: особенно везучим пользователям могут достаться
          крайне редкие предметы, которые ценятся во&nbsp;всем игровом сообществе!
        </Text>
        <Spacer space={32} spacemob={24} />
        <Text color="white">
          Сервис МТС Оплата поможет не&nbsp;упустить свой шанс в&nbsp;исполнении новогодних желаний. Площадка
          предоставляет услугу безопасной покупки игр в&nbsp;Steam, так что сделать подарок самому себе или своим
          близким, купив игровые новинки или классические, давно зарекомендовавшие себя бестселлеры, стало еще проще.
          Так, держим руку на&nbsp;пульсе и готовимся к&nbsp;новогодней распродаже вместе с&nbsp;МТС Оплата!
        </Text>
      </>,
    date: '18.12.2023',
    imagePage: steam,
    imageSlide: steamSlide,
    titleMeta: 'Любимые игры по спеццене! – МТС Оплата',
    descriptionMeta: 'С 21 декабря по 4 января пользователи могут не только купить с большими скидками игры, которые давно хранятся в списке желаемых, но и поучаствовать в различных квестах - выбирайте игру и добавьте ее к себе в коллекцию вместе с МТС Оплатой!'
  }
};

require("./News.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./News.tsx");